import { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, OverlayTrigger, Tooltip, Table, Modal} from "react-bootstrap";
import api from "../../services/api";
import { perguntasDaCategoria } from '../../common/config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import ModalAceitesPrograma from "../Base/ModalAceitesPrograma";
import { formatarValor, validaSenha, hasPerm, tiposAcesso, getCurrentUser, MidiasAceita } from '../../common/utils';
import { IMaskInput } from "react-imask";
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { FaCheck, FaTimes, FaStream, FaEye, FaEyeSlash, FaEnvelope, FaFilePdf, FaPlus, FaTrash } from "react-icons/fa";
import PrestadorKits from './PrestadorKits';
import PrestadorCentrosReferencia from './PrestadorCentrosReferencia';
import { getConfig } from "../../common/config";

class MedicosEdit extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);
        //this.onChangeCep = this.onChangeCep.bind(this);
        this.onChangeGrupo = this.onChangeGrupo.bind(this);
        this.handleProgramaChange = this.handleProgramaChange.bind(this);

        this.onChangeImagem = this.onChangeImagem.bind(this);

        this.list_tipos_pessoa = {
            "fisica": "Física",
            "juridica": "Jurídica"
        };
        this.list_categorias = {
            "medicos": "Médicos",
            "multiprofissionais": "Multiprofissionais",
            "farmacias": "Farmácias",
            "hospitais": "Hospitais",
            "clinicas": "Clínicas",
            "plataformas": "Plataformas",
            "laboratorio_diagnostico": "Laboratórios de Diagnósticos"
        };
        this.list_generos = {
            "F": "Feminino",
            "M": "Masculino",
            "O": "Outro",
        };
        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };

        this.state = {
            nome: '',
            cpf: '',
            cnpj: '',
            email: "",
            razao_social: "",
            nome_fantasia: "",
            tipo_pessoa: "fisica",
            telefone: "",
            celular: "",
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            cep: '',
            uf: '',
            cidade: '',
            genero: '',
            registro: '',
            registro_uf: '',
            categoria: 'medicos',
            contato_nome: '',
            contato_email: '',
            contato_celular: '',
            representante: '',
            mentor: false,
            imagem_upload: '',
            logomarca_pdf_termo: '',
            imagemHelper: "",
            nomeHelper: "",
            cpfHelper: "",
            cnpjHelper: "",
            emailHelper: "",
            razaoSocialHelper: "",
            nomeFantasiaHelper: "",
            tipoPessoaHelper: "",
            telefoneHelper: "",
            celularHelper: "",
            enderecoHelper: "",
            numeroHelper: '',
            complementoHelper: '',
            bairroHelper: '',
            cepHelper: '',
            ufHelper: '',
            cidadeHelper: '',
            generoHelper: '',
            registroHelper: '',
            registroUfHelper: '',
            categoriaHelper: '',
            contatoNomeHelper: '',
            contatoEmailHelper: '',
            contatoCelularHelper: '',
            representanteHelper: '',
            titulo_pagina: "",
            loading: false,
            erroLoadRegistro: '',
            prestador_id: '',
            grupo_id: '',
            grupo_nome: '',
            is_active: false,
            cliente_id: this.props.dados_cliente?.cliente_id || '',
            cliente_nome: this.props.dados_cliente?.cliente_nome || '',
            especialidade_id: '',
            especialidade_nome: '',
            categoria_multiprofissional_id: '',
            categoria_multiprofissional_nome: '',
            especialidade_multiprofissional_id: '',
            especialidade_multiprofissional_nome: '',
            // HNS-1594: medico que indicou esse multiprofissional (opcional).
            medico_indicou_id: '',
            medico_indicou_nome: '',
            programa_uuid: this.props.dados_programa?.programa_uuid || '',
            programa_id: this.props.dados_programa?.programa_id || '',
            programa_nome: this.props.dados_programa?.programa_nome || '',
            termo_prestador_id: '',
            termo_prestador_nome: '',
            assinatura_letssign: '',
            alerta_atendimento: '',

            especialidades: [],
            especialidades_medicas: [],
            clientes: [],
            laboratorios: [],
            programas: [],
            vinculoAceitesModal: null,
            senha: '',
            senha_confirma: '',
            mostrarSenha: { senha: false, senhaConfirma: false },
            requisitosSenha: {
                tamanho: false,
                minuscula: false,
                maiuscula: false,
                numero: false,
                especial: false
            },
            permite_editar: true,
            acesso_unico: true,
            midiasContato: [],
            is_active: true,
            // Campos para Termos Opt-in
            termo_assinado_optin_medicos: [],  // Array de objetos {url, url_assinada, nome, data_upload}
            termos_upload_files: [],
            data_aceite_termo: null,
            prestador_uuid: '',
            enviando_solicitacao_optin: false,
            uploadingTermoAssinado: false,
            exige_aceite_termo_opt_in_medicos: true, // Default seguro: só faz aceite automatico quando a config do programa disser explicitamente false
            // Campos para Centros de Referência
            centrosReferencia: [],
            centroSelecionado: null,
            loadingCentros: false,
            showModalCentro: false,
            novoCentro: {
                nome: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cep: '',
                uf: '',
                cidade: '',
                responsavel_recebimento: '',
                telefone: '',
            },
            salvandoCentro: false,
            // Campos para Gestão de Usuários
            usuarios: [],
            showModalUsuario: false,
            usuarioAtual: {
                id: '',
                email: '',
                username: '',
                is_active: true,
                first_name: '',
                last_name: '',
                password: '',
                password_confirm: '',
                grupo_id: ''
            },
            usuarioErrors: {},
            criar_usuario_medico_optin: false, // Flag do programa para habilitar criação de usuário
            receber_comunicacoes: false,
            loadingCRM: false,
            crmValidado: false,
            // Campos Dinamicos NPS/Termos
            nps_termos_campos_dinamicos: null,
            nps_termos_campos_dinamicos_respostas: {},
            // Respostas dos termos dinamicos do medico (Termos_Dinamicos) marcadas pela navegadora no cadastro
            termos_dinamicos_respostas: {},
            programa_dados: {},
            campoOcultoMedico: [],
        };
    }

    componentDidMount(){
        this.carregarDadosPrestadores();
    }

    carregarDadosPrestadores = () => {

        let dados_usuario = getCurrentUser();

        const id = this.props.router.params.id;

        if (id) {
            this.setState({
                prestador_id: id,
                loading: true,
                erroLoadRegistro: '',
            });

            // Consulta os dados do prestador na API
            api.get(`/pessoas/prestadores/${id}`)
                .then(response => {
                    const dados = response.data;
                    // Tratando dados recebidos para garantir que não tenham valores nulos ou "null"
                    const dadosPessoa = this.tratarNulos(dados);

                    const programa_id = dados_usuario['ambiente_programa_id'] || '';
    
                    // Preenche os inputs com os dados tratados
                    this.setState({
                        erroLoadRegistro: '',
                        nome: dadosPessoa.nome,
                        cpf: dadosPessoa.tipo_pessoa === 'fisica' ? dadosPessoa.cpf_cnpj : '',
                        cnpj: dadosPessoa.tipo_pessoa === 'juridica' ? dadosPessoa.cpf_cnpj : '',
                        email: dadosPessoa.email,
                        razao_social: dadosPessoa.razao_social,
                        nome_fantasia: dadosPessoa.nome_fantasia,
                        tipo_pessoa: dadosPessoa.tipo_pessoa,
                        telefone: dadosPessoa.telefone,
                        celular: dadosPessoa.celular,
                        endereco: dadosPessoa.endereco,
                        numero: dadosPessoa.numero,
                        complemento: dadosPessoa.complemento,
                        bairro: dadosPessoa.bairro,
                        cep: dadosPessoa.cep,
                        uf: dadosPessoa.uf,
                        cidade: dadosPessoa.cidade,
                        genero: dadosPessoa.genero,
                        mentor: dadosPessoa.mentor,
                        especialidades_medicas: dados.dados_especialidades_medicas?.map(item => ({
                            value: item.id,
                            label: item.nome,
                        })) || [],
                        registro: dadosPessoa.registro,
                        registro_uf: dadosPessoa.registro_uf,
                        categoria: dadosPessoa.categoria,
                        contato_nome: dadosPessoa.contato_nome,
                        contato_email: dadosPessoa.contato_email,
                        contato_celular: dadosPessoa.contato_celular,
                        representante: dadosPessoa.representante,
                        logomarca_pdf_termo: dadosPessoa.logomarca_pdf_termo,
                        cliente_id: dadosPessoa.cliente_id,
                        cliente_nome: dadosPessoa.dados_cliente.nome,
                        especialidade_id: dadosPessoa.especialidade_id,
                        categoria_multiprofissional_id: dadosPessoa.categoria_multiprofissional_id,
                        medico_indicou_id: dadosPessoa.medico_indicou_id || '',
                        medico_indicou_nome: dadosPessoa.dados_medico_indicou?.nome || '',
                        programa_uuid: dadosPessoa.dados_programa.uuid,
                        programa_nome: dadosPessoa.dados_programa.nome,
                        termo_prestador_id: dadosPessoa.termo_prestador_id,
                        termo_prestador_nome: dadosPessoa.dados_termo_prestador.nome,
                        assinatura_letssign: dadosPessoa.assinatura_letssign,
                        alerta_atendimento: dadosPessoa.alerta_atendimento,
                        acesso_unico: dados.acesso_unico || dadosPessoa.dados_programa.uuid ? true : false,
                        midiasContato: dadosPessoa.midias_contato
                            ? dadosPessoa.midias_contato.split(',')
                            : [],
                        loading: false,
                        titulo_pagina: 'Editando Médico: ' + dadosPessoa.nome,
                        is_active: dadosPessoa.is_active,
                        // Campos Termos Opt-in
                        termo_assinado_optin_medicos: dadosPessoa.termo_assinado_optin_medicos || [],
                        data_aceite_termo: dadosPessoa.data_aceite_termo || null,
                        prestador_uuid: dados.uuid || '',
                        exige_aceite_termo_opt_in_medicos: dadosPessoa.dados_programa?.exige_aceite_termo_opt_in_medicos ?? true,
                        programa_id: programa_id,
                        receber_comunicacoes: dadosPessoa.receber_comunicacoes || false,
                        // Se já tem CRM preenchido, considera validado
                        crmValidado: !!dadosPessoa.registro && !!dadosPessoa.registro_uf,
                        nps_termos_campos_dinamicos_respostas: dadosPessoa.nps_termos_campos_dinamicos 
                            ? dadosPessoa.nps_termos_campos_dinamicos.reduce((acc, item) => {
                                acc[item.slug] = item.resposta;
                                return acc;
                            }, {})
                            : {},
                    });
    
                    // Carrega dados completos do programa para pegar exige_aceite_termo_opt_in_medicos
                    if (dadosPessoa.dados_programa?.uuid) {
                        this.carregaDadosPrograma(dadosPessoa.dados_programa.uuid);
                    }

                    this.carregarProgramasPrestador();
                    this.carregarLaboratoriosMedico();
                    this.carregarCentrosPrestador();
                    this.carregarUsuariosMedico();

                })
                .catch(error => {
                    let erro_msg = 'Erro ao consultar médico, tente novamente';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    });
                });
        } else {
            if (!hasPerm('add_prestadores')) {
                window.location.href = '/sem-permissao';
                return;
            }
    
            const programa_id = dados_usuario['ambiente_programa_id'] || '';
            
            this.setState({
                prestador_id: '',
                titulo_pagina: 'Adicionar Médico',
                loading: false,
                erroLoadRegistro: '',
                cliente_id: dados_usuario['ambiente_cliente_id'] || '',
                programa_id: programa_id,
            });

            // Carrega dados do programa também no cadastro novo via uuid
            const programa_uuid = dados_usuario['ambiente_programa_uuid'] || '';
            if (programa_uuid) {
                this.carregaDadosPrograma(programa_uuid);
            }
        }
    };


    // Carrega dados completos do programa para pegar configurações específicas
    carregaDadosPrograma = (programa_uuid) => {
        api.get(`/programas/${programa_uuid}/`)
            .then(response => {
                const programaDados = response.data;
                
                // Tenta pegar de configuracoes ou da raiz
                const config = programaDados.configuracoes || {};
                const criarUsuarioOptin = config.criar_usuario_medico_optin !== undefined 
                    ? config.criar_usuario_medico_optin 
                    : programaDados.criar_usuario_medico_optin;

                const ocultarCampos = config?.ocultar_campos_medico || [];

                
                this.setState({
                    exige_aceite_termo_opt_in_medicos: programaDados.exige_aceite_termo_opt_in_medicos ?? true,
                    criar_usuario_medico_optin: criarUsuarioOptin || false,
                    programa_id: programaDados.id,
                    nps_termos_campos_dinamicos: config.nps_termos_campos_dinamicos || null,
                    programa_dados: programaDados,
                    campoOcultoMedico: ocultarCampos,
                });
            })
            .catch(error => {
                console.error('Erro ao carregar dados do programa:', error);
            });
    }

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });
            }
        }
    }

    verificaRequisitosSenha = (senha) => {
        const requisitos = {
            tamanho: senha.length > 8,
            minuscula: /[a-z]/.test(senha),
            maiuscula: /[A-Z]/.test(senha),
            numero: /[0-9]/.test(senha),
            especial: /[$@#&!]/.test(senha)
        };
        this.setState({ requisitosSenha: requisitos });
    }

    tratarNulos = (obj) => {
        const novoObjeto = {};
        for (let key in obj) {
            novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
        }
        return novoObjeto;
    };

    handleMidiasChange = ({ target: { value, checked } }) => {
        this.setState(prev => {
            const setMedias = new Set(prev.midiasContato);
            checked ? setMedias.add(value) : setMedias.delete(value);
            return { midiasContato: Array.from(setMedias) };
        });
    }

    handleTermoDinamicoChange = (slug, valor) => {
        this.setState(prevState => ({
            nps_termos_campos_dinamicos_respostas: {
                ...prevState.nps_termos_campos_dinamicos_respostas,
                [slug]: valor
            }
        }), () => {
            // Auto-save após atualizar o estado
            // Verifica se tem ID (edição)
            if (this.state.prestador_id) {
                this.salvarTermosDinamicos();
            }
        });
    }

    preparaFormData = () => {
        let dados_usuario = getCurrentUser();

        const cachedPogramaTipo = localStorage.getItem(`programa_tipo_${dados_usuario['ambiente_programa_id']}`);

        if (this.state.senha) {
            if (!validaSenha(this.state.senha)) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Senha Fraca',
                    text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                    showCloseButton: true,
                });
                return;
            }

            if (this.state.senha !== this.state.senha_confirma) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Erro',
                    text: 'As senhas não coincidem.',
                    showCloseButton: true,
                });
                return; // Para interromper a execução se houver erro
            }
        }

        // Verifica se é edição ou adição
        const url = this.state.prestador_id ? '/pessoas/prestadores/' + this.state.prestador_id + '/' : '/pessoas/prestadores/';
        const metodo = this.state.prestador_id ? 'put' : 'post';

        if(cachedPogramaTipo === 'medimentor' && metodo === 'post') {
            if(!this.state.grupo_id) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor, selecione o Grupo de Usuário do médico.',
                    showCloseButton: true,
                });
                return;
            }

            if(!this.state.senha) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'warning',
                    title: 'Atenção!',
                    text: 'Por favor, informe uma senha e confirmação de senha para o médico.',
                    showCloseButton: true,
                });
                return;
            }
        }

        // Prepara os dados para o envio
        const formData = new FormData();

        const cliente_id = dados_usuario['ambiente_cliente_id'] || this.state.cliente_id;
        const programa_uuid = dados_usuario['ambiente_programa_uuid'] || this.state.programa_uuid;
        const especialidades_medicas_ids = this.state.especialidades_medicas.map(especialidade => parseInt(especialidade.value));

        const dadosTratados = this.tratarNulos({
            nome: this.state.tipo_pessoa === 'fisica' ? this.state.nome : this.state.razao_social,
            email: this.state.email,
            razao_social: this.state.razao_social,
            nome_fantasia: this.state.nome_fantasia,
            tipo_pessoa: this.state.tipo_pessoa,
            telefone: this.state.telefone,
            celular: this.state.celular,
            endereco: this.state.endereco,
            numero: this.state.numero,
            complemento: this.state.complemento,
            bairro: this.state.bairro,
            cep: this.state.cep,
            uf: this.state.uf,
            cidade: this.state.cidade,
            categoria: this.state.categoria,
            mentor: this.state.mentor,
            contato_nome: this.state.contato_nome,
            contato_email: this.state.contato_email,
            contato_celular: this.state.contato_celular,
            representante: this.state.representante,
            genero: this.state.tipo_pessoa === 'fisica' ? this.state.genero : '',
            especialidade_multiprofissional_id: this.state.especialidade_multiprofissional_id || '',
            termo_prestador_id: this.state.termo_prestador_id || '',
            assinatura_letssign: this.state.assinatura_letssign,
            alerta_atendimento: this.state.alerta_atendimento || '',
            acesso_unico: this.state.acesso_unico || false,
            midias_contato: this.state.midiasContato.join(','),
            is_active: this.state.is_active,
            receber_comunicacoes: this.state.receber_comunicacoes
        });

        if(this.state.email) {
            if(this.state.grupo_id) {
                // Era gravado em cpf_cnpj (linha original de 02/02/2026): o backend nunca
                // recebia grupo_id e nao criava o usuario, e o medico sem CPF ficava com o
                // id do grupo no campo de CPF -- dai o "CPF ja cadastrado" no cadastro
                // seguinte. Sao os QA bugs 18 e 19, mesma causa.
                dadosTratados['grupo_id'] = this.state.grupo_id;
            }

            if(this.state.senha && this.state.grupo_id) {
                dadosTratados['senha'] = this.state.senha;
            }
        }

        formData.append('especialidades_medicas', especialidades_medicas_ids.join(','));

        if(this.state.tipo_pessoa === 'fisica') {
            if(this.state.cpf) {
                dadosTratados['cpf_cnpj'] = this.state.cpf;
            }
        } else {
            if(this.state.cnpj) {
                dadosTratados['cpf_cnpj'] = this.state.cnpj;
            }
        }

        if(this.state.categoria != 'medicos' && this.state.categoria != 'multiprofissionais') {
            dadosTratados['registro'] = '1';
            dadosTratados['registro_uf'] = 'SP';
        } else {
            if(this.state.registro) {
                dadosTratados['registro'] = this.state.registro;
            }
            if(this.state.registro_uf) {
                dadosTratados['registro_uf'] = this.state.registro_uf;
            }
        }

        if(this.state.acesso_unico && metodo === 'post') {
            dadosTratados['cliente_id'] = cliente_id;
            dadosTratados['programa_uuid'] = programa_uuid;
        }

        if (this.state.categoria_multiprofissional_id) {
            dadosTratados.categoria_multiprofissional_id = this.state.categoria_multiprofissional_id;
        }

        // HNS-1594: medico_indicou_id so faz sentido pra multiprofissional.
        // Em FormData null vira a string "null" e o serializer recusa, entao: com valor manda
        // o id; sem valor manda string vazia SO na edicao (para desvincular quem ja tinha) e
        // omite na criacao, senao o cadastro de quem nao foi indicado por medico quebra.
        if (this.state.categoria === 'multiprofissionais') {
            if (this.state.medico_indicou_id) {
                dadosTratados.medico_indicou_id = this.state.medico_indicou_id;
            } else if (this.state.prestador_id) {
                dadosTratados.medico_indicou_id = '';
            }
        }

        Object.keys(dadosTratados).forEach(key => {
            formData.append(key, dadosTratados[key]);
        });

        if (this.state.imagem_upload) {
            formData.append('logomarca_pdf_termo', this.state.imagem_upload);
        }

        // Flag para controle de aceite automático de termos  
        // Se exige_aceite_termo_opt_in_medicos = False, aceite é automático
        const aceiteAutomatico = !this.state.exige_aceite_termo_opt_in_medicos;
        formData.append('aceite_automatico_termos', aceiteAutomatico ? 'true' : 'false');

        // Adiciona campos dinâmicos de termos se houver configuração e estiver ativo
        if (this.state.nps_termos_campos_dinamicos && this.state.nps_termos_campos_dinamicos.ativo) {
            const respostasFormatadas = this.state.nps_termos_campos_dinamicos.perguntas.map(pergunta => ({
                slug: pergunta.slug,
                pergunta: pergunta.label,
                resposta: this.state.nps_termos_campos_dinamicos_respostas[pergunta.slug]
            })).filter(item => item.resposta !== undefined); 
            
            formData.append('nps_termos_campos_dinamicos', JSON.stringify(respostasFormatadas));
        }

        // Termos dinamicos do medico marcados pela navegadora no cadastro (novo medico).
        // Na edicao os aceites vao pela aba de optin, entao so envia no cadastro.
        if (!this.state.prestador_id) {
            const respostasTD = this.state.termos_dinamicos_respostas || {};
            if (Object.keys(respostasTD).length > 0) {
                formData.append('termos_dinamicos_respostas_json', JSON.stringify(respostasTD));
            }
        }

        return formData;
    }

    salvarTermosDinamicos = () => {
        const formData = this.preparaFormData();

        api({
            method: 'put',
            url: `/pessoas/prestadores/${this.state.prestador_id}/`,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'success',
                title: 'Preferência salva',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000
            });
        })
        .catch(error => {
            console.error('Erro ao salvar termos automaticamente:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro ao salvar preferência',
                text: 'Não foi possível salvar a alteração automaticamente. Tente salvar o formulário completo.',
                showCloseButton: true,
                toast: true,
                position: 'top-end',
                timer: 3000
            });
        });
    }

    enviaRegistro = (e) => {
        e.preventDefault();
        let dados_usuario = getCurrentUser();
    
        if (this.state.senha) {
            if (!validaSenha(this.state.senha)) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Senha Fraca',
                    text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                    showCloseButton: true,
                });
                return;
            }
    
            if (this.state.senha !== this.state.senha_confirma) {
                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'As senhas não coincidem.',
                    showCloseButton: true,
                });
                return;
            }
        }

        // Os termos do médico NÃO são obrigatórios aqui: quem preenche esta tela é a
        // navegadora, e o aceite é ato do próprio médico — ele responde no seu optin ou na
        // tela de aceite enviada a ele. Exigir aqui obrigaria a navegadora a responder no
        // lugar dele. O bloqueio por resposta negativa continua valendo quando o programa
        // o configura, para o caso de ela preencher junto com o médico.
        if (!this.state.prestador_id) {
            const cfgTD = this.state.programa_dados?.configuracoes?.Termos_Dinamicos;
            if (cfgTD?.habilitado_termo_dinamico_medico && Array.isArray(cfgTD.Questions)) {
                const respostasTD = this.state.termos_dinamicos_respostas || {};

                // Quando o medico responde a opcao de nao consentimento (ex.: "Nao autorizo"),
                // bloqueia o cadastro com mensagem amigavel antes de enviar ao backend.
                let mensagemBloqueio = '';
                cfgTD.Questions.forEach((q) => {
                    if (!q?.slug) return;
                    const regraBloqueio = q.regra_bloqueio_cadastro || {};
                    if (regraBloqueio.ativo === true && respostasTD[q.slug] === regraBloqueio.quando_valor) {
                        mensagemBloqueio = regraBloqueio.mensagem
                            || 'O consentimento para cadastro não foi aceito. Para prosseguir, é necessário aceitar o consentimento.';
                    }
                });
                if (mensagemBloqueio) {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'warning',
                        title: 'Atenção',
                        html: mensagemBloqueio,
                        showCloseButton: true,
                    });
                    return;
                }
            }
        }

        const url = this.state.prestador_id ? '/pessoas/prestadores/' + this.state.prestador_id + '/' : '/pessoas/prestadores/';
        const metodo = this.state.prestador_id ? 'put' : 'post';
    
        const formData = this.preparaFormData();

        this.setState({ loading: true });

        // Envia para API
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            const textSwal = this.state.prestador_id ? 'Médico atualizado com sucesso' : 'Médico cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loading: false });
    
            // Se exige aceite de termos E tem email, pergunta se quer enviar email de opt-in
            if (!this.state.prestador_id && this.state.exige_aceite_termo_opt_in_medicos && this.state.email) {
                MySwal.fire({
                    icon: 'question',
                    title: 'Enviar solicitação de aceite de termos?',
                    html: `Deseja enviar um e-mail para <strong>${this.state.email}</strong> com o link para aceite dos termos?`,
                    showCancelButton: true,
                    confirmButtonText: 'Sim, enviar',
                    cancelButtonText: 'Não',
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Envia email de opt-in
                        api.post('/termos/prestador/solicitar-optin/', {
                            prestador_id: response.data.id,
                        })
                        .then(() => {
                            MySwal.fire({
                                icon: 'success',
                                title: 'E-mail enviado!',
                                text: 'A solicitação de aceite foi enviada com sucesso.',
                                showCloseButton: true,
                            });
                        })
                        .catch(error => {
                            console.error('Erro ao enviar opt-in:', error);
                            MySwal.fire({
                                icon: 'error',
                                title: 'Erro ao enviar e-mail',
                                text: 'Não foi possível enviar a solicitação. Você pode enviar depois pela aba Termos.',
                                showCloseButton: true,
                            });
                        });
                    }
                });
            }
    
            // Caso seja chamado o componente via componente pai, atualiza o componente pai
            // Atualmente está sendo chamado no AtendimentosEdit.jsx
            if (this.props.onAtualizar) {
                const dados_medico = {
                    medico_id: response.data.id,
                    medico_nome: response.data.nome
                }
                this.props.onAtualizar(dados_medico);
            }
            else if (!this.state.prestador_id) {
                // Redireciona
                this.props.router.navigate("/medicos");
            }
        })
        .catch(error => {
            let erro_msg = "Erro ao realizar o cadastro:<br />";

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const responseData = error.response.data;
                const campos = responseData.erros ? responseData.erros : responseData;

                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    // Normaliza o valor para leitura (DRF pode retornar arrays/objetos aninhados,
                    // que sem tratamento apareceriam como "[object Object]").
                    let valueTexto;
                    if (Array.isArray(value)) {
                        valueTexto = value.join(' ');
                    } else if (value !== null && typeof value === 'object') {
                        valueTexto = Object.values(value).flat().join(' ');
                    } else {
                        valueTexto = value;
                    }

                    erro_msg += "<br />" + key + ": " + valueTexto;

                    this.setState({ [`${key}Helper`]: value });

                    if(key === 'nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'cpf_cnpj'){
                        this.setState({
                            cpfHelper: value,
                            cnpjHelper: value
                        })
                    }
                    if(key === 'email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'razao_social'){
                        this.setState({ razaoSocialHelper: value })
                    }
                    if(key === 'nome_fantasia'){
                        this.setState({ nomeFantasiaHelper: value })
                    }
                    if(key === 'tipo_pessoa'){
                        this.setState({ tipoPessoaHelper: value })
                    }
                    if(key === 'telefone'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'celular'){
                        this.setState({ celularHelper: value })
                    }
                    if(key === 'endereco'){
                        this.setState({ enderecoHelper: value })
                    }
                    if(key === 'numero'){
                        this.setState({ numeroHelper: value })
                    }
                    if(key === 'complemento'){
                        this.setState({ complementoHelper: value })
                    }
                    if(key === 'bairro'){
                        this.setState({ bairroHelper: value })
                    }
                    if(key === 'cep'){
                        this.setState({ cepHelper: value })
                    }
                    if(key === 'uf'){
                        this.setState({ ufHelper: value })
                    }
                    if(key === 'cidade'){
                        this.setState({ cidadeHelper: value })
                    }
                    if(key === 'genero'){
                        this.setState({ generoHelper: value })
                    }
                    if(key === 'registro'){
                        this.setState({ registroHelper: value })
                    }
                    if(key === 'registro_uf'){
                        this.setState({ registroUfHelper: value })
                    }
                    if(key === 'categoria'){
                        this.setState({ categoriaHelper: value })
                    }
                    if(key === 'contato_nome'){
                        this.setState({ contatoNomeHelper: value })
                    }
                    if(key === 'contato_email'){
                        this.setState({ contatoEmailHelper: value })
                    }
                    if(key === 'contato_celular'){
                        this.setState({ contatoCelularHelper: value })
                    }
                    if(key === 'representante'){
                        this.setState({ representanteHelper: value })
                    }
                    if(key === 'logomarca_pdf_termo'){
                        this.setState({ imagemHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: erro_msg,
            })

            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (event, fieldName) => {
        if(fieldName == 'beneficiario_id') {
            this.setState({ beneficiario_id: event.value, beneficiario_nome: event.label });
        }
        else if (fieldName == "servico_procedimento_id") {
            this.setState({ servico_procedimento_id: event.value, servico_procedimento_nome: event.label });
        }
        else if (fieldName == "situacao") {
            this.setState({ situacao: event.value, situacao_nome: event.label });
        }
        else if (fieldName == "valor") {
            const { name, value } = event.target;
            this.setState({ [name]: formatarValor(value) });
        }
        else if (fieldName == 'cliente_id') {
            this.setState({
                cliente_id: event.value,
                cliente_nome: event.label,
                programa_uuid: '',  // Limpa o ID do programa selecionado
                programa_nome: '',  // Limpa o nome do programa selecionado
            });
        }
        else if (fieldName == 'categoria_multiprofissional_id') {
            this.setState({
                categoria_multiprofissional_id: event.value,
                categoria_multiprofissional_nome: event.label,
            });
        }
        else if (fieldName == 'especialidade_multiprofissional_id') {
            this.setState({
                especialidade_multiprofissional_id: event.value,
                especialidade_multiprofissional_nome: event.label,
            });
        }
        else if (fieldName == 'medico_indicou_id') {
            // event pode ser null quando o AsyncSelect eh limpado (isClearable)
            this.setState({
                medico_indicou_id: event?.value || '',
                medico_indicou_nome: event?.label || '',
            });
        }
        else if (fieldName == 'programa_uuid') {
            this.setState({
                programa_uuid: event.value,
                programa_nome: event.label,
            });
        }
        else if (fieldName == 'termo_prestador_id'){
            this.setState({
                termo_prestador_id: event.value,
                termo_prestador_nome: event.label,
            });
        }
        else if (fieldName == 'assinatura_letssign'){
            this.setState({
                assinatura_letssign: event.target.checked
            });
        }
        else {
            const { name, value } = event.target;
            
            // Se alterar CRM ou UF do CRM, reseta a validação
            if (name === 'registro' || name === 'registro_uf') {
                this.setState({ [name]: value, crmValidado: false });
            } else {
                this.setState({ [name]: value });
            }
        }
    };

    handleEspecialidadesChange = (selectedOption) => {
        const especialidadesMedicas = selectedOption || [];
        this.setState({ especialidades_medicas: especialidadesMedicas });
    };
    
    // Função para consultar CRM
    consultaCRM = async () => {
        const MySwal = withReactContent(Swal);

        if(!this.state.registro || !this.state.registro_uf) {
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                text: 'Por favor, preencha o CRM e UF',
                showCloseButton: true,
            });
            return;
        }

        this.setState({ loadingCRM: true });

        try {
            const response = await api.get(
                `/pessoas/crm/?registro=${this.state.registro}&uf=${this.state.registro_uf}`
            );
            const data = response.data;
        
            if (data.valido) {
                this.setState({
                    crmValidado: true,
                    nome: data.dados_medico.nome_medico,
                    loadingCRM: false,
                });
                
                MySwal.fire({
                    icon: 'success',
                    title: 'CRM Válido!',
                    text: `Médico: ${data.dados_medico.nome_medico}`,
                    showCloseButton: true,
                    timer: 3000,
                });
            } else {
                this.setState({ crmValidado: false, loadingCRM: false });
                MySwal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    text: 'O CRM informado não é válido.',
                    showCloseButton: true,
                });
            }
        } catch (error) {
            this.setState({ loadingCRM: false, crmValidado: false });
            console.error('Erro na consulta CRM:', error);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                text: 'O CRM informado não é válido.',
                showCloseButton: true,
            });
        }
    }

    onChangeImagem = (e) => {
        this.setState({ imagem_upload: e.target.files[0] });
    };

    onChangeTipoPessoa = (e) => {
        this.setState({
            tipo_pessoa: e.target.value,
            cpf: '',
            cnpj: '',
        });
    };

    onChangeGrupo = (grupoSelecionado) => {
        this.setState({ grupo_id: grupoSelecionado ? grupoSelecionado.value : '', grupo_nome: grupoSelecionado ? grupoSelecionado.label : '' });
    };

    /*
    onChangeCategoria = (categoriaSelecionado) => {
        this.setState({ categoria_multiprofissional_id: categoriaSelecionado ? categoriaSelecionado.value : '', categoria_multiprofissional_nome: categoriaSelecionado ? categoriaSelecionado.label : '' });
    };*/

    fetchCep = (cepDigits) => {
        if (cepDigits.length === 8 || cepDigits.length === 9) { // Verifica se o CEP tem 9 caracteres
            axios.get(`https://viacep.com.br/ws/${cepDigits}/json/`)
                .then(res => {
                    if (!res.data.erro) {
                        const cepAtual = String(this.state.cep || '').replace(/\D/g, '');
                        const cepConsulta = String(cepDigits || '').replace(/\D/g, '');

                        if (cepAtual !== cepConsulta) {
                            return;
                        }

                        this.setState((prevState) => ({
                            endereco: res.data.logradouro,
                            complemento: prevState.complemento || res.data.complemento || '',
                            bairro: res.data.bairro,
                            cidade: res.data.localidade,
                            uf: res.data.uf
                        }));
                    } else {
                        // Tratar o caso de CEP não encontrado
                    }
                })
                .catch(error => {
                    // Tratar erro na requisição
                    console.error("Erro na requisição:", error);
                });
        }
    }

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    //Laboratórios do Médico
    carregarLaboratoriosMedico = () => {
        if (this.state.prestador_id) {
            api.get(`/pessoas/prestadores/laboratorios/?medico_id=${this.state.prestador_id}`)
                .then(response => {
                    const laboratoriosCarregados = response.data.results.map(laboratorio => ({
                        id: laboratorio.id,
                        laboratorio_id: laboratorio.laboratorio_id,
                        laboratorio_nome: `${laboratorio.dados_laboratorio.nome_fantasia} (${laboratorio.dados_laboratorio.razao_social})`
                    }));
                    this.setState({ laboratorios: laboratoriosCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar laboratórios:', error);

                    let erro_msg = 'Erro ao carregar laboratórios do médico, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    salvarLaboratorio = (index) => {
        const laboratorio = this.state.laboratorios[index];
        const url = (laboratorio.id) ? `/pessoas/prestadores/laboratorios/${laboratorio.id}/` : '/pessoas/prestadores/laboratorios/';
        const metodo = (laboratorio.id) ? 'put' : 'post';

        const dadosLaboratorio = {
            medico_id: this.state.prestador_id,
            laboratorio_id: laboratorio.laboratorio_id
        };

        api({
            method: metodo,
            url: url,
            data: dadosLaboratorio,
        })
        .then(response => {
            // Se for um novo laboratorio, atualize o estado com a ID retornada pela API
            if (!laboratorio.id) {
                this.setState(prevState => {
                    const laboratoriosAtualizados = [...prevState.laboratorios];
                    laboratoriosAtualizados[index].id = response.data.id;
                    return { laboratorios: laboratoriosAtualizados };
                });
            }

            const MySwal = withReactContent(Swal)
            const textSwal = (laboratorio.id) ? 'Laboratório atualizado com sucesso' : 'Laboratório cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o laboratório, verifique os campos e tente novamente';
            let content = '';

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;

                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'laboratorio_id') {
                        content += `<br>&bull; Laboratório: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarLaboratorio = () => {
        this.setState(prevState => ({
            laboratorios: [...prevState.laboratorios, { laboratorio_id: '', laboratorio_nome: '' }],
        }));
    };

    removerLaboratorio = (index) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Remover laboratório?',
            text: "Tem certeza que deseja remover este laboratório?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const laboratorio = this.state.laboratorios[index];

                if (laboratorio.id) {

                    const url = `/pessoas/prestadores/laboratorios/${laboratorio.id}/`;
                    const metodo = 'delete';

                    api({
                        method: metodo,
                        url: url,
                    })
                    .then(response => {

                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Laboratório removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            laboratorios: prevState.laboratorios.filter((_, i) => i !== index),
                        }));

                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o laboratório, tente novamente';

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;

                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        laboratorios: prevState.laboratorios.filter((_, i) => i !== index),
                    }));

                    MySwal.fire(
                        'Removido!',
                        'O laboratório foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleLaboratorioChange = (index, event, fieldName) => {
        const laboratorios = [...this.state.laboratorios];
        if (fieldName === 'laboratorio_id') {
            laboratorios[index] = { ...laboratorios[index], laboratorio_id: event.value, laboratorio_nome: event.label };
        } else {
            const { name, value } = event.target;
            laboratorios[index] = { ...laboratorios[index], [name]: value };
        }
        this.setState({ laboratorios });
    };

    carregarLaboratorios = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/prestadores/?nome=${inputValue}&categoria=laboratorio_diagnostico|servicos_diagnostico|clinicas|hospitais|cooperativas_saude`);
            const opcoes = response.data.results.map(laboratorio => ({
                value: laboratorio.id,
                label: `${laboratorio.dados_pessoa.nome_fantasia} (${laboratorio.dados_pessoa.razao_social})`
            }));

            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar laboratorios:', error);
            return [];
        }
    };

    //  Centros de Referência
    carregarCentrosPrestador = () => {
        if (this.state.prestador_id) {
            this.setState({ loadingCentros: true });
            api.get(`/centros_referencia/prestadores/?prestador_id=${this.state.prestador_id}`)
                .then(response => {
                    this.setState({ 
                        centrosReferencia: response.data.results || [],
                        loadingCentros: false 
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar centros de referência:', error);
                    this.setState({ loadingCentros: false });
                });
        }
    };

    carregarCentrosReferencia = async (inputValue) => {
        try {
            const response = await api.get(`/centros_referencia/?nome=${inputValue}`);
            const opcoes = response.data.results.map(centro => ({
                value: centro.id,
                label: centro.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar centros de referência:', error);
            return [];
        }
    };

    handleCentroChange = (selectedOption) => {
        this.setState({ centroSelecionado: selectedOption });
    };

    adicionarCentroReferencia = () => {
        const { centroSelecionado, prestador_id, centrosReferencia } = this.state;
        
        if (!centroSelecionado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'Selecione um centro de referência para adicionar.',
            });
            return;
        }

        // Verifica se já está vinculado
        const jaVinculado = centrosReferencia.some(c => c.centro_referencia_id === centroSelecionado.value);
        if (jaVinculado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'info',
                title: 'Já vinculado',
                text: 'Este centro de referência já está vinculado a este médico.',
            });
            return;
        }

        api.post('/centros_referencia/prestadores/', {
            centro_referencia_id: centroSelecionado.value,
            prestador_id: prestador_id
        })
        .then(() => {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: 'Centro de referência vinculado com sucesso.',
                timer: 2000,
                showConfirmButton: false
            });
            this.setState({ centroSelecionado: null });
            this.carregarCentrosPrestador();
        })
        .catch(error => {
            console.error('Erro ao vincular centro:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: 'Erro ao vincular centro de referência.',
            });
        });
    };

    removerCentroReferencia = (relacaoId) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            title: 'Remover centro?',
            text: 'Tem certeza que deseja remover este centro de referência?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/centros_referencia/prestadores/${relacaoId}/`)
                    .then(() => {
                        MySwal.fire({
                            icon: 'success',
                            title: 'Removido!',
                            text: 'Centro de referência removido.',
                            timer: 2000,
                            showConfirmButton: false
                        });
                        this.carregarCentrosPrestador();
                    })
                    .catch(error => {
                        console.error('Erro ao remover centro:', error);
                        MySwal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro ao remover centro de referência.',
                        });
                    });
            }
        });
    };

    // Modal de Criar Centro de Referência
    abrirModalCentro = () => {
        this.setState({
            showModalCentro: true,
            novoCentro: {
                nome: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cep: '',
                uf: '',
                cidade: '',
                responsavel_recebimento: '',
                telefone: '',
            },
        });
    };

    fecharModalCentro = () => {
        this.setState({ showModalCentro: false });
    };

    handleNovoCentroChange = (event) => {
        const { name, value } = event.target;
        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                [name]: value
            }
        }));
    };

    handleNovoCentroMaskAccept = (fieldName) => (value) => {
        this.setState(prevState => ({
            novoCentro: {
                ...prevState.novoCentro,
                [fieldName]: value
            }
        }));
    };

    salvarNovoCentro = () => {
        const { novoCentro, prestador_id } = this.state;

        if (!novoCentro.nome.trim()) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção',
                text: 'O campo Nome é obrigatório.',
            });
            return;
        }

        this.setState({ salvandoCentro: true });

        // Primeiro cria o centro
        api.post('/centros_referencia/', novoCentro)
            .then(response => {
                const novoCentroId = response.data.id;
                const novoCentroNome = response.data.nome;

                // Depois vincula ao prestador
                return api.post('/centros_referencia/prestadores/', {
                    centro_referencia_id: novoCentroId,
                    prestador_id: prestador_id
                }).then(() => {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: `Centro "${novoCentroNome}" criado e vinculado com sucesso.`,
                        timer: 2500,
                        showConfirmButton: false
                    });

                    this.setState({ 
                        salvandoCentro: false, 
                        showModalCentro: false 
                    });
                    this.carregarCentrosPrestador();
                });
            })
            .catch(error => {
                console.error('Erro ao criar centro:', error);
                let erro_msg = 'Erro ao criar centro de referência.';
                
                if (error.response?.data) {
                    const campos = error.response.data;
                    for (let key in campos) {
                        erro_msg += `\n${key}: ${campos[key]}`;
                    }
                }

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: erro_msg,
                });
                this.setState({ salvandoCentro: false });
            });
    };

    
    carregarUsuariosMedico = () => {
        if (this.state.prestador_id) {
            this.setState({ loading: true });
            // Usando prestador_id conforme padrão do PrestadoresEdit, pois restricao_id parece ser ignorado
            api.get(`/usuarios/?prestador_id=${this.state.prestador_id}`)
                .then(response => {
                    const usuariosCarregados = response.data.results.map(usuario => {
                        // Backend retorna grupos_list
                        const grupos = usuario.grupos_list || usuario.groups || [];
                        const primeiroGrupo = grupos.length > 0 ? { value: grupos[0].id, label: grupos[0].name } : null;

                        return {
                            id: usuario.id,
                            email: usuario.email,
                            username: usuario.username,
                            is_active: usuario.is_active,
                            first_name: usuario.first_name,
                            last_name: usuario.last_name,
                            grupo_id: primeiroGrupo
                        };
                    });
                    this.setState({ usuarios: usuariosCarregados, loading: false });
                })
                .catch(error => {
                    console.error('Erro ao carregar usuários:', error);
                    this.setState({ loading: false });
                });
        }
    };

    handleShowModalUsuario = (usuario = null) => {
        this.setState({ usuarioErrors: {} });

        if (usuario) {
            this.setState({
                usuarioAtual: {
                    id: usuario.id,
                    email: usuario.email,
                    username: usuario.username,
                    is_active: usuario.is_active,
                    first_name: usuario.first_name,
                    last_name: usuario.last_name,
                    grupo_id: usuario.grupo_id,
                    password: '',
                    password_confirm: ''
                },
                showModalUsuario: true
            });
        } else {
            // Pré-preenche dados do novo usuário com base nos dados do médico
            const nomeMedico = this.state.nome || '';
            const partesNome = nomeMedico.trim().split(/\s+/);
            const firstName = partesNome[0] || '';
            const lastName = partesNome.slice(1).join(' ') || '';
            
            // Gera username: nome completo em minúsculo, sem acentos e caracteres especiais
            const username = nomeMedico
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '') // Remove acentos
                .replace(/[^a-z0-9]/g, '') // Remove tudo que não é letra ou número
                || '';

            this.setState({
                usuarioAtual: {
                    id: '',
                    email: this.state.email || '',
                    username: username,
                    is_active: true,
                    first_name: firstName,
                    last_name: lastName,
                    password: '',
                    password_confirm: '',
                    grupo_id: ''
                },
                showModalUsuario: true
            });
        }
    };

    handleCloseModalUsuario = () => {
        this.setState({ 
            showModalUsuario: false,
        });
    };

    handleChangeUsuarios = (e) => {
        const { name, value, type, checked } = e.target;
        this.setState(prevState => ({
            usuarioAtual: {
                ...prevState.usuarioAtual,
                [name]: type === 'checkbox' ? checked : value
            }
        }));
    };

    handleChangeUsuariosSelect = (field) => (selectedOption) => {
        this.setState(prevState => ({
            usuarioAtual: {
                ...prevState.usuarioAtual,
                [field]: selectedOption
            }
        }));
    };

    handleSubmitUsuario = (e) => {
        e.preventDefault();
        const { usuarioAtual, prestador_id } = this.state;       

        const errors = {};

        if (!usuarioAtual.first_name) {
            errors.first_name = 'Nome é obrigatório';
        }

        if (!usuarioAtual.last_name) {
            errors.last_name = 'Sobrenome é obrigatório';
        }

        if (!usuarioAtual.username) {
            errors.username = 'Nome de usuário é obrigatório';
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ usuarioErrors: errors });
            return;
        }

        const payload = {
            is_active: usuarioAtual.is_active,
            first_name: usuarioAtual.first_name,
            last_name: usuarioAtual.last_name,
            email: usuarioAtual.email,
            username: usuarioAtual.username,            
            grupos: [usuarioAtual.grupo_id ? usuarioAtual.grupo_id.value : null]
        };        

        // cadastro - SEM SENHA, backend vai criar automaticamente
        if(!usuarioAtual.id){
            // restricoes
            payload['restricoes'] = {
                'id': prestador_id,
                'tipo': 'prestador'
            }            
        } else {
            // edição - senha opcional
            if (usuarioAtual.password) {
                if (!validaSenha(usuarioAtual.password)) {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'warning',
                        title: 'Atenção',
                        text: 'Sua senha deve ter mais de 8 caracteres, incluir pelo menos uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
                        showCloseButton: true,
                    });
                    return;
                }
        
                if (usuarioAtual.password !== usuarioAtual.password_confirm) {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'warning',
                        title: 'Atenção!',
                        text: 'As senhas não coincidem.',
                        showCloseButton: true,
                    });
                    return;
                }

                // senha
                payload['password'] = usuarioAtual.password;
            }
        }

        const method = usuarioAtual.id ? 'put' : 'post';
        const url = usuarioAtual.id 
            ? `/usuarios/${usuarioAtual.id}/`
            : '/usuarios/';
        
        this.setState({ loading: true });

        api({
            method,
            url,
            data: payload
        })
        .then(response => {
            const MySwal = withReactContent(Swal);
            
            let mensagemSucesso = usuarioAtual.id ? 'Usuário atualizado com sucesso' : 'Usuário criado com sucesso! A senha foi gerada automaticamente e enviada por email.';
            
            MySwal.fire({
                icon: 'success',
                title: 'Sucesso',
                text: mensagemSucesso,
                showConfirmButton: true,
                timer: 3000
            });

            this.setState({ usuarioErrors: {}, loading: false });

            this.carregarUsuariosMedico();
            this.handleCloseModalUsuario();
        })
        .catch(error => {
            console.error('Erro ao salvar usuário:', error);

            const errorsFromApi = {};
            let mensagem = 'Erro ao salvar o usuário, verifique os campos.';
            let isGenericError = false;

            if (error.response && error.response.data) {
                const data = error.response.data;

                if (typeof data === 'object') {
                    Object.entries(data).forEach(([field, msg]) => {
                        const text = Array.isArray(msg) ? msg.join(' ') : String(msg);

                        if (field === 'detail' || field === 'non_field_errors') {
                            mensagem = text;
                            isGenericError = true;
                        } else {
                            errorsFromApi[field] = text;
                        }
                    });

                    if (!isGenericError) {
                        mensagem = 'Erro ao salvar o usuário, verifique os campos.';
                    }
                } else {
                    mensagem = String(data);
                }
            }

            this.setState({ 
                usuarioErrors: errorsFromApi,
                loading: false
            });

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Erro',
                text: mensagem,
                showConfirmButton: true,
            });
        });
    };

    handleRemoverUsuario = (id) => {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
            icon: 'warning',
            title: 'Atenção',
            text: 'Tem certeza que deseja inativar este usuário?',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/usuarios/${id}/`)
                    .then(() => {
                        MySwal.fire({
                            icon: 'success',
                            title: 'Sucesso',
                            text: 'Usuário removido com sucesso',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.carregarUsuariosMedico();
                    })
                    .catch(error => {
                        console.error('Erro ao inativar usuário:', error);
                        MySwal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Não foi possível inativar o usuário',
                            showConfirmButton: true
                        });
                    });
            }
        });
    };

    carregarClientesPrograma = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };


    carregarProgramasCliente = async (inputValue, cliente_id) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${cliente_id}&programa_id=${this.state.programa_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.uuid,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    carregarProgramasClienteRepetidor = async (inputValue, cliente_id) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas do cliente:', error);
            return [];
        }
    };

    carregarTermos = async (inputValue) => {
        try{
            const response = await api.get(`/termos/?titulo=${inputValue}`);
            const opcoes = response.data.results.map(termo => ({
                value: termo.id,
                label: termo.titulo
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar termos:', error);
            return [];
        }
    }

    carregarEspecialidades = async (inputValue) => {
        try {
            const response = await api.get(`/profissionais/especialidades-medicas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(especialidade => ({
                value: especialidade.id,
                label: especialidade.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar especialidades:', error);
            return [];
        }
    };

    carregarCategoriaMultiprofissional = async (inputValue) => {
        try {
            const response = await api.get(`/profissionais/categorias-multiprofissionais/?nome=${inputValue}`);
            const opcoes = response.data.results.map(categoria => ({
                value: categoria.id,
                label: categoria.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar especialidades:', error);
            return [];
        }
    };

    // HNS-1594: busca medicos do programa atual pra selecao "medico que indicou".
    // Filtra por categoria='medicos'; se houver programa_id no state, restringe pra
    // evitar apontar pra medico de outro cliente.
    carregarMedicosParaIndicacao = async (inputValue) => {
        try {
            let url = `/pessoas/prestadores/?categoria=medicos&limit=20&nome=${encodeURIComponent(inputValue || '')}`;
            if (this.state.programa_id) {
                url += `&programa_id=${this.state.programa_id}`;
            }
            const response = await api.get(url);
            const rows = response.data?.results || response.data || [];
            return rows.map(m => ({
                value: m.id,
                label: `${m.nome}${m.registro ? ` (CRM ${m.registro}/${m.registro_uf || ''})` : ''}`,
            }));
        } catch (error) {
            console.error('Erro ao carregar medicos:', error);
            return [];
        }
    };

    carregarEspecialidadeMultiprofissional = async (inputValue) => {
        try {
            //`especialidades-` no plural: o endpoint e esse. No singular dava 404, o catch
            //devolvia [] e a lista aparecia vazia sem nenhum sinal de erro.
            const response = await api.get(`/profissionais/especialidades-multiprofissionais/?nome=${inputValue}`);
            const opcoes = response.data.results.map(multiprofissionais => ({
                value: multiprofissionais.id,
                label: multiprofissionais.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar especialidades:', error);
            return [];
        }
    };

    //Programas do Prestador
    carregarProgramasPrestador = () => {
        if (this.state.prestador_id) {
            api.get(`/programas/prestadores/?prestador_id=${this.state.prestador_id}`)
                .then(response => {
                    console.error(response)
                    const programasCarregados = response.data.results.map(programa => ({
                        id: programa.id,
                        programa_id: programa.programa_id,
                        programa_nome: programa.dados_programa.nome,
                        termo_prestador_id: programa.termo_prestador_id,
                        termo_prestador_nome: programa.dados_termo_prestador.nome,
                        data_aceite_termo: programa.data_aceite_termo,
                        ip_aceite_termos: programa.ip_aceite_termos || null,
                        termos_dinamicos_perguntas_json: programa.termos_dinamicos_perguntas_json || null,
                        termos_dinamicos_respostas_json: programa.termos_dinamicos_respostas_json || null,
                        cliente_id: programa.cliente_id,
                        assinatura_letssign: programa.assinatura_letssign,
                        alerta_atendimento: programa.alerta_atendimento,
                        exclusivo_vinculados: programa.exclusivo_vinculados,
                        cliente_nome: `${programa.dados_cliente.nome_fantasia} (${programa.dados_cliente.razao_social})`
                    }));
                    this.setState({ programas: programasCarregados });
                })
                .catch(error => {
                    console.error('Erro ao carregar programas:', error);

                    let erro_msg = 'Erro ao carregar programas do médico, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    temAceiteRegistrado = (vinculo) => {
        if (!vinculo) return false;

        const respostas = vinculo.termos_dinamicos_respostas_json;
        const temRespostas = !!respostas && typeof respostas === 'object' && Object.keys(respostas).length > 0;

        return temRespostas || !!vinculo.data_aceite_termo;
    };

    abrirModalAceites = (vinculo) => this.setState({ vinculoAceitesModal: vinculo });

    fecharModalAceites = () => this.setState({ vinculoAceitesModal: null });

    /**
     * A aba "Termos" só existe em programa que exige aceite manual, e a aba "Programas" some para quem
     * acessa dentro de um ambiente de programa — então o atalho para os aceites fica junto dos dados.
     */
    renderBotaoAceitesProgramaAtual = () => {
        const vinculo = this.getProgramaVinculoAtual();
        if (!this.temAceiteRegistrado(vinculo)) return null;

        return (
            <Button
                variant="outline-secondary"
                className="btn-sm mt-2"
                onClick={() => this.abrirModalAceites(vinculo)}
            >
                Ver aceites do programa
            </Button>
        );
    };

    getProgramaVinculoAtual = () => {
        const programas = this.state.programas || [];
        if (!programas.length) return null;

        const programaIdAtual = Number(this.state.programa_id || 0);
        if (programaIdAtual) {
            const vinculo = programas.find((p) => Number(p.programa_id) === programaIdAtual);
            if (vinculo) return vinculo;
        }

        const programaNomeAtual = (this.state.programa_nome || '').trim().toLowerCase();
        if (programaNomeAtual) {
            const vinculoPorNome = programas.find((p) => String(p.programa_nome || '').trim().toLowerCase() === programaNomeAtual);
            if (vinculoPorNome) return vinculoPorNome;
        }

        // Se existir vínculo com aceite, prioriza para evitar falso "sem registro".
        const vinculoComAceite = programas.find((p) => !!p.data_aceite_termo);
        if (vinculoComAceite) return vinculoComAceite;

        return programas[0];
    };

    parseJsonOrObject = (payload) => {
        if (!payload) return null;
        if (typeof payload === 'object') return payload;
        if (typeof payload === 'string') {
            try {
                return JSON.parse(payload);
            } catch (_) {
                return null;
            }
        }
        return null;
    };

    getDadosAceitesTermosPersonalizados = () => {
        const vinculoAtual = this.getProgramaVinculoAtual();

        const perguntasSalvas = this.parseJsonOrObject(vinculoAtual?.termos_dinamicos_perguntas_json);
        const respostasSalvas = this.parseJsonOrObject(vinculoAtual?.termos_dinamicos_respostas_json);

        //sem snapshot salvo, cai na config -- filtrada pela categoria deste profissional
        const perguntasConfig = perguntasDaCategoria(
            this.state.programa_dados?.configuracoes?.Termos_Dinamicos?.Questions, this.state.categoria);
        const perguntas = Array.isArray(perguntasSalvas)
            ? perguntasSalvas
            : (Array.isArray(perguntasConfig) ? perguntasConfig : []);

        const respostas = (respostasSalvas && typeof respostasSalvas === 'object') ? respostasSalvas : {};

        return { vinculoAtual, perguntas, respostas };
    };

    formatarRespostaTermoPersonalizado = (pergunta, valor) => {
        if (valor === undefined || valor === null || valor === '') {
            return <span className="text-muted">Não respondido</span>;
        }

        if (typeof valor === 'boolean') {
            return (
                <span className={`badge ${valor ? 'bg-success' : 'bg-danger'}`}>
                    {valor ? 'Aceito' : 'Não aceito'}
                </span>
            );
        }

        if (pergunta?.tipo === 'radio' && Array.isArray(pergunta?.opcoes)) {
            const opcaoSelecionada = pergunta.opcoes.find((opcao) => {
                if (typeof opcao === 'object') {
                    return opcao?.valor === valor;
                }
                return opcao === valor;
            });

            if (opcaoSelecionada) {
                const label = typeof opcaoSelecionada === 'object'
                    ? (opcaoSelecionada.label ?? String(opcaoSelecionada.valor))
                    : String(opcaoSelecionada);
                return <span>{label}</span>;
            }
        }

        return <span>{String(valor)}</span>;
    };

    handleChangeTermoDinamico = (slug, valor) => {
        this.setState(prev => ({
            termos_dinamicos_respostas: { ...prev.termos_dinamicos_respostas, [slug]: valor }
        }));
    };

    // Termos dinamicos do medico editaveis, para a NAVEGADORA marcar no CADASTRO (novo medico).
    // Na EDICAO nao aparece aqui (os aceites vao para a aba de optin). Config: Termos_Dinamicos.
    renderTermosDinamicosCadastroMedico = () => {
        if (this.state.prestador_id) return null; // so no cadastro (novo)
        const cfg = this.state.programa_dados?.configuracoes?.Termos_Dinamicos;
        if (!cfg?.habilitado_termo_dinamico_medico) return null;
        const perguntasDaTela = perguntasDaCategoria(cfg.Questions, this.state.categoria);
        if (!perguntasDaTela.length) return null;

        return (
            <div className="mt-4">
                <h5>{cfg.titulo || 'Consentimentos do Médico'}</h5>
                {perguntasDaTela.map((q, idx) => {
                    const slug = q?.slug;
                    const valorAtual = slug ? this.state.termos_dinamicos_respostas?.[slug] : undefined;
                    return (
                        <Form.Group className="mb-3" key={slug || `td_${idx}`}>
                            {/* sem asterisco: nesta tela o consentimento é opcional — quem
                                aceita é o médico, no optin dele ou na tela de aceite */}
                            <Form.Label className="fw-bold d-block mb-1">
                                {q?.label || q?.pergunta || slug}
                            </Form.Label>
                            {(q?.texto || q?.descricao) && (
                                <div className="text-muted mb-2" style={{ whiteSpace: 'pre-line' }}>
                                    {q?.texto || q?.descricao}
                                </div>
                            )}
                            {q?.tipo === 'radio' && Array.isArray(q?.opcoes) ? (
                                <div>
                                    {q.opcoes.map((op, i) => {
                                        const opValor = (op && typeof op === 'object') ? op.valor : op;
                                        const opLabel = (op && typeof op === 'object') ? (op.label ?? String(op.valor)) : op;
                                        return (
                                            <Form.Check
                                                key={`${slug}_${i}`}
                                                inline type="radio"
                                                name={`td_${slug}`}
                                                id={`td_${slug}_${i}`}
                                                label={opLabel}
                                                checked={valorAtual === opValor}
                                                onChange={() => this.handleChangeTermoDinamico(slug, opValor)}
                                            />
                                        );
                                    })}
                                </div>
                            ) : (
                                <Form.Check
                                    type="checkbox"
                                    id={`td_${slug}`}
                                    label={q?.opcoes_label || 'Concordo'}
                                    checked={valorAtual === true}
                                    onChange={(e) => this.handleChangeTermoDinamico(slug, e.target.checked)}
                                />
                            )}
                        </Form.Group>
                    );
                })}
            </div>
        );
    };

    /**
     * Há respostas de termo do médico para consultar. Serve para exibir a aba mesmo quando o
     * programa não usa aceite manual: a navegadora e o administrador precisam ver o que o
     * médico respondeu, e antes isso ficava preso na mesma flag que abre o fluxo de
     * solicitação de aceite.
     */
    temRespostasTermosParaConsulta = () => {
        if (!this.state.programa_dados?.configuracoes?.Termos_Dinamicos?.habilitado_termo_dinamico_medico) return false;
        const { vinculoAtual } = this.getDadosAceitesTermosPersonalizados();
        return !!vinculoAtual?.termos_dinamicos_respostas_json;
    };

    renderAceitesTermosPersonalizadosPrograma = () => {
        const termosDinamicosHabilitado = this.state.programa_dados?.configuracoes?.Termos_Dinamicos?.habilitado_termo_dinamico_medico;
        if (!termosDinamicosHabilitado) return null;

        const { vinculoAtual, perguntas, respostas } = this.getDadosAceitesTermosPersonalizados();

        if (!vinculoAtual?.termos_dinamicos_respostas_json) return null;

        return (
            <div className="mt-4">
                <h5>Aceites de Termos Personalizados do Programa</h5>

                {(() => {
                    const dataAceite = vinculoAtual?.data_aceite_termo || this.state.data_aceite_termo;
                    return dataAceite ? (
                        <small className="text-muted d-block mb-2">
                            Aceite registrado em {new Date(dataAceite).toLocaleDateString('pt-BR')}
                        </small>
                    ) : (
                        <small className="text-muted d-block mb-2">
                            Sem registro de aceite para o programa vinculado.
                        </small>
                    );
                })()}

                {!perguntas.length ? (
                    <Alert variant="light" className="mb-0">
                        Não há perguntas de termos personalizados configuradas para este programa.
                    </Alert>
                ) : (
                    perguntas.map((pergunta, index) => {
                        const slug = pergunta?.slug;
                        const label = pergunta?.label || slug || `Pergunta ${index + 1}`;
                        const textoPergunta = pergunta?.pergunta || pergunta?.texto || '';
                        const valor = slug ? respostas?.[slug] : undefined;

                        return (
                            <div key={slug || `aceite_termo_${index}`} className="border rounded p-2 mb-2 bg-light">
                                <div className="fw-semibold mb-1">{label}</div>
                                {!!textoPergunta && textoPergunta !== label && (
                                    <div className="text-muted mb-1">{textoPergunta}</div>
                                )}
                                <div>{this.formatarRespostaTermoPersonalizado(pergunta, valor)}</div>
                            </div>
                        );
                    })
                )}
            </div>
        );
    };

    salvarPrograma = (index) => {
        const programa = this.state.programas[index];
        const url = (programa.id) ? `/programas/prestadores/${programa.id}/` : '/programas/prestadores/';
        const metodo = (programa.id) ? 'put' : 'post';

        const dadosPrograma = {
            prestador_id: this.state.prestador_id,
            cliente_id: programa.cliente_id,
            programa_id: programa.programa_id,
            assinatura_letssign: programa.assinatura_letssign,
            exclusivo_vinculados: programa.exclusivo_vinculados || false
        };

        if(programa.alerta_atendimento) {
            dadosPrograma['alerta_atendimento'] = programa.alerta_atendimento;
        }

        if(programa.termo_prestador_id) {
            dadosPrograma['termo_prestador_id'] = programa.termo_prestador_id;
        }

        api({
            method: metodo,
            url: url,
            data: dadosPrograma,
        })
        .then(response => {
            // Se for um novo programa, atualize o estado com a ID retornada pela API
            if (!programa.id) {
                this.setState(prevState => {
                    const programasAtualizados = [...prevState.programas];
                    programasAtualizados[index].id = response.data.id;
                    return { programas: programasAtualizados };
                });
            }

            const MySwal = withReactContent(Swal)
            const textSwal = (programa.id) ? 'Programa atualizado com sucesso' : 'Programa cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o programa, verifique os campos e tente novamente';
            let content = '';

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;

                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'programa_id') {
                        content += `<br>&bull; Programa: ${value}`;
                    }
                    if(key == 'cliente_id') {
                        content += `<br>&bull; Cliente: ${value}`;
                    }
                    if(key == 'termo_prestador_id') {
                        content += `<br>&bull; Termo: ${value}`;
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    };

    adicionarPrograma = () => {
        this.setState(prevState => ({
            programas: [...prevState.programas, { cliente_id: '', cliente_nome: '', programa_id: '', programa_nome: '', termo_prestador_id: '', termo_prestador_nome: '', data_aceite_termo: '', assinatura_letssign: false, 'alerta_atendimento': '', exclusivo_vinculados: '' }],
        }));
    };

    removerPrograma = (index) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Remover programa?',
            text: "Tem certeza que deseja remover este programa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {

                const programa = this.state.programas[index];

                if (programa.id) {

                    const url = `/programas/prestadores/${programa.id}/`;
                    const metodo = 'delete';

                    api({
                        method: metodo,
                        url: url,
                    })
                    .then(response => {

                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Programa removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.setState(prevState => ({
                            programas: prevState.programas.filter((_, i) => i !== index),
                        }));

                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o programa, tente novamente';

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;

                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        programas: prevState.programas.filter((_, i) => i !== index),
                    }));

                    MySwal.fire(
                        'Removido!',
                        'O programa foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleProgramaChange = (index, event, fieldName) => {
        const programas = [...this.state.programas];
        if (fieldName === 'cliente_id') {
            // Reseta o programa quando o cliente é alterado
            programas[index] = {
                ...programas[index],
                cliente_id: event.value,
                cliente_nome: event.label,
                programa_id: '',  // Limpa o ID do programa selecionado
                programa_nome: '',  // Limpa o nome do programa selecionado
                // Adiciona uma chave para forçar a re-renderização do AsyncSelect de programas
                keyPrograma: new Date().getTime()
            };
        } else if (fieldName === 'programa_id') {
            programas[index] = { ...programas[index], programa_id: event.value, programa_nome: event.label };
        } else if (fieldName === 'termo_prestador_id'){
            programas[index] = { ...programas[index], termo_prestador_id: event.value, termo_prestador_nome: event.label };
        } else if (fieldName === 'assinatura_letssign'){
            programas[index] = { ...programas[index], assinatura_letssign: event.target.checked };
        } else if (fieldName === 'alerta_atendimento'){
            programas[index] = { ...programas[index], alerta_atendimento: event.target.value };
        }
        else if (fieldName === 'exclusivo_vinculados'){
            programas[index] = { ...programas[index], exclusivo_vinculados: event.target.checked };
        }

        this.setState({ programas });
    };

    // Função para alternar a visibilidade da senha
    toggleSenhaVisibilidade = campo => {
        this.setState(prevState => ({
            mostrarSenha: { ...prevState.mostrarSenha, [campo]: !prevState.mostrarSenha[campo] }
        }));
    }

    carregarGrupos = async (inputValue) => {
        try {
            const response = await api.get(`/grupos/?nome=${inputValue}`);
            
            // Lista de nomes permitidos
            const nomesPermitidos = [
                'Medimentor Mentorado',
                'Medimentor Prestador',
                'Médicos Prestadores'
            ];
            
            // Filtrar os grupos com base nos nomes permitidos
            const opcoes = response.data.results
                .filter(grupo => nomesPermitidos.includes(grupo.name))
                .map(grupo => ({
                    value: grupo.id,
                    label: grupo.name
                }));
            
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar grupos:', error);
            return [];
        }
    };

    logomarcaTermo() {
        const renderTooltip = (props) => (
            <Tooltip id="button-tooltip" {...props}>
              Logomarca que é exibida no cabeçalho do termo PDF do laboratório e que é assinado pelo paciente
            </Tooltip>
        );

        return (
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderTooltip}
            >
                <Button variant="tooltip" size="sm">?</Button>
            </OverlayTrigger>
        );
    }

    handleMaskAccept = (field) => (value, mask) => {
        this.setState({ [field]: value });
    }

    // Handler para upload de termos assinados (múltiplos PDFs)
    onChangeTermoAssinado = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            this.setState({ uploadingTermoAssinado: true });

            // Upload dos arquivos
            const formData = new FormData();
            files.forEach(file => {
                formData.append('termos', file);
            });

            api.post(`/pessoas/prestadores/${this.state.prestador_id}/upload-termos/`, formData)
                .then(response => {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: `${response.data.total} termo(s) enviado(s) com sucesso.`,
                        showCloseButton: true,
                    });
                    this.setState({ 
                        uploadingTermoAssinado: false,
                        termo_assinado_optin_medicos: response.data.termos || []
                    });
                    e.target.value = '';
                })
                .catch(error => {
                    console.error('Erro ao enviar termo assinado:', error);
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro!',
                        text: 'Não foi possível enviar o(s) termo(s). Tente novamente.',
                        showCloseButton: true,
                    });
                    this.setState({ uploadingTermoAssinado: false });
                });
        }
    }

    // Handler para remover um termo assinado específico
    removerTermoAssinado = (urlTermo) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            icon: 'warning',
            title: 'Confirmar remoção',
            text: 'Deseja realmente remover este termo assinado?',
            showCancelButton: true,
            confirmButtonText: 'Sim, remover',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#dc3545',
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ uploadingTermoAssinado: true });

                api.delete(`/pessoas/prestadores/${this.state.prestador_id}/remover-termo/`, {
                    data: { url: urlTermo }
                })
                    .then(response => {
                        MySwal.fire({
                            icon: 'success',
                            title: 'Removido!',
                            text: 'Termo removido com sucesso.',
                            showCloseButton: true,
                        });
                        this.setState({ 
                            uploadingTermoAssinado: false,
                            termo_assinado_optin_medicos: response.data.termos || []
                        });
                    })
                    .catch(error => {
                        console.error('Erro ao remover termo:', error);
                        MySwal.fire({
                            icon: 'error',
                            title: 'Erro!',
                            text: 'Não foi possível remover o termo. Tente novamente.',
                            showCloseButton: true,
                        });
                        this.setState({ uploadingTermoAssinado: false });
                    });
            }
        });
    }

    // Handler para enviar solicitação de opt-in por email
    enviarSolicitacaoOptin = () => {
        const MySwal = withReactContent(Swal);

        if (!this.state.prestador_uuid) {
            MySwal.fire({
                icon: 'error',
                title: 'Erro!',
                text: 'UUID do prestador não disponível.',
                showCloseButton: true,
            });
            return;
        }

        const jaAceitou = !!this.state.data_aceite_termo;

        MySwal.fire({
            title: jaAceitou ? 'Confirmar reenvio' : 'Confirmar envio',
            text: jaAceitou
                //quem já aceitou merece saber que vai receber o link de novo e aceitar outra vez
                ? 'Este médico já registrou um aceite. Deseja enviar novamente o link para que ele aceite os termos?'
                : 'Deseja enviar uma solicitação de aceite de termos para o e-mail do médico?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: jaAceitou ? 'Sim, reenviar' : 'Sim, enviar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ enviando_solicitacao_optin: true });

                // Endpoint para disparo de email (a ser criado no backend)
                api.post('/termos/prestador/solicitar-optin/', {
                    prestador_id: this.state.prestador_id,
                    prestador_uuid: this.state.prestador_uuid
                })
                .then(() => {
                    MySwal.fire({
                        icon: 'success',
                        title: 'Enviado!',
                        text: 'Solicitação de aceite de termos enviada por e-mail.',
                        showCloseButton: true,
                    });
                    this.setState({ enviando_solicitacao_optin: false });
                })
                .catch(error => {
                    console.error('Erro ao enviar solicitação:', error);
                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro!',
                        text: 'Não foi possível enviar a solicitação. Tente novamente.',
                        showCloseButton: true,
                    });
                    this.setState({ enviando_solicitacao_optin: false });
                });
            }
        });
    }

    // Copia o link de aceite de termos para a área de transferência
    copiarLinkAceiteTermos = () => {
        const programaRef = this.state.programa_uuid || this.state.programa_id || '';
        const sufixoPrograma = programaRef ? `?p=${programaRef}` : '';
        const link = `${window.location.origin}/termos-medico/aceite/${this.state.prestador_uuid}${sufixoPrograma}`;
        navigator.clipboard.writeText(link).then(() => {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'success',
                title: 'Link copiado!',
                text: 'O link foi copiado para a área de transferência.',
                timer: 2000,
                showConfirmButton: false
            });
        });
    }

    handleOcultoMedico = (slug) => {
        const { campoOcultoMedico } = this.state;
        return Array.isArray(campoOcultoMedico) && campoOcultoMedico.includes(slug);
    };

    renderModalUsuario = () => {
        const { showModalUsuario, usuarioAtual } = this.state;
        
        return (
            <Modal show={showModalUsuario} size="lg" onHide={this.handleCloseModalUsuario}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {usuarioAtual.id ? 'Editar usuário' : 'Adicionar usuário'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={this.handleSubmitUsuario}>
                        <Row>
                            <Col sm={12}>
                                <Form.Group className="mb-3">
                                    <Form.Check
                                        type="checkbox"
                                        name="is_active"
                                        id="is_active"
                                        label={
                                            <>
                                            Ativo <span className="text-danger">*</span>
                                            </>
                                        }
                                        checked={!!this.state.usuarioAtual.is_active}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.is_active}
                                    />
                                    {this.state.usuarioErrors.is_active && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.is_active}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nome <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="first_name"
                                        required
                                        placeholder="Nome"
                                        value={this.state.usuarioAtual.first_name || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.first_name}
                                    />
                                    {this.state.usuarioErrors.first_name && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.first_name}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Sobrenome <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="last_name"
                                        required
                                        placeholder="Sobrenome"
                                        value={this.state.usuarioAtual.last_name || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.last_name}
                                    />
                                        {this.state.usuarioErrors.last_name && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.last_name}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        E-mail <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        required
                                        placeholder="E-mail"
                                        value={this.state.usuarioAtual.email || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.email}
                                    />
                                        {this.state.usuarioErrors.email && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.email}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Nome de usuário <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        required
                                        placeholder="Nome de usuário"
                                        value={this.state.usuarioAtual.username || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.username}
                                    />
                                        {this.state.usuarioErrors.username && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.username}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={12} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Grupo de permissões </Form.Label>
                                    <AsyncSelect
                                        required
                                        cacheOptions
                                        loadOptions={this.carregarGrupos}
                                        defaultOptions
                                        name="grupo_id"
                                        placeholder="Buscar grupo..."
                                        noOptionsMessage={() => "Nenhum grupo encontrado"}
                                        onChange={this.handleChangeUsuariosSelect('grupo_id')}
                                        className={this.state.usuarioErrors.grupo_id ? 'is-invalid' : ''}
                                        value={this.state.usuarioAtual.grupo_id || null}
                                    />
                                    {this.state.usuarioErrors.grupo_id && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.grupo_id}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                        {
                        /* Para novos usuários, NÃO mostrar campos de senha */
                        !usuarioAtual.id && (
                            <Alert variant="info">
                                <strong>Atenção:</strong> A senha será gerada automaticamente pelo sistema e enviada por e-mail para o usuário.
                            </Alert>
                        )}
                        {
                        /* Para edição, mostrar campos de senha OPCIONAIS */
                        usuarioAtual.id && (
                        <Row>
                            <Col sm={12}>
                                <Alert variant="info" className="mb-3">
                                    <strong>Alterar senha (opcional):</strong> Deixe em branco para manter a senha atual.
                                </Alert>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3 position-relative">
                                    <Form.Label>
                                        Nova Senha
                                    </Form.Label>
                                    <Form.Control
                                        type={this.state.mostrarSenha.password ? "text" : "password"}
                                        name="password"
                                        placeholder="Nova Senha"
                                        value={this.state.usuarioAtual.password || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.password}
                                    />
                                    <i
                                        onClick={() => this.toggleSenhaVisibilidade('password')}
                                        className="senha-icon"
                                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                    >
                                        {this.state.mostrarSenha.password ? <FaEyeSlash /> : <FaEye />}
                                    </i>
                                    {this.state.usuarioErrors.password && (
                                        <Form.Control.Feedback type="invalid">
                                            {this.state.usuarioErrors.password}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3 position-relative">
                                    <Form.Label>
                                        Confirmar Nova Senha
                                    </Form.Label>
                                    <Form.Control
                                        type={this.state.mostrarSenha.password_confirm ? "text" : "password"}
                                        name="password_confirm"
                                        placeholder="Confirmar Senha"
                                        value={this.state.usuarioAtual.password_confirm || ''}
                                        onChange={this.handleChangeUsuarios}
                                        isInvalid={!!this.state.usuarioErrors.password}
                                    />
                                    <i
                                        onClick={() => this.toggleSenhaVisibilidade('password_confirm')}
                                        className="senha-icon"
                                        style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                    >
                                        {this.state.mostrarSenha.password_confirm ? <FaEyeSlash /> : <FaEye />}
                                    </i>
                                </Form.Group>
                            </Col>
                        </Row>
                        )}
                        
                        <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                            {this.state.loading ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    };

    render() {

    let dados_usuario = getCurrentUser();

    /*if(this.state.loading) {
        return;
    }*/

    if(!this.state.permite_editar){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={12}>
                        <h5 className="page-title">Vocẽ não tem permissão para acessar essa página</h5>
                    </Col>
                </Row>
            </div>
        );
    }

        const cachedPogramaTipo = localStorage.getItem(`programa_tipo_${dados_usuario['ambiente_programa_id']}`);
        const ocultar_centros_referencia = getConfig(this.state.programa_dados?.configuracoes, "medicos.ocultar_centros_referencia", false);
        const ocultar_kits = getConfig(this.state.programa_dados?.configuracoes, "medicos.ocultar_kits", false);

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosPrestador" id="tabs-prestador" className="aditus-tabs">
                    <Tab eventKey="dadosPrestador" title="Dados do médico">
                        <Card className="cardDestaque">
                            <Card.Body>
                                <Form onSubmit={this.enviaRegistro}>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Label>Tipo Pessoa</Form.Label>
                                            <div className="mb-3">
                                            {
                                                Object.keys(this.list_tipos_pessoa).map((key, index) => (
                                                <Form.Check inline type="radio" label={this.list_tipos_pessoa[key]} key={key} id={key} name="tipo_pessoa" value={key} onChange={this.onChangeTipoPessoa} checked={ key === this.state.tipo_pessoa ? true : false } />
                                                ))
                                            }
                                            </div>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CRM <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="registro" 
                                                    required 
                                                    placeholder="CRM" 
                                                    value={this.state.registro} 
                                                    onChange={this.handleChange} 
                                                />    
                                                <Form.Text id="registroHelper" className="text-danger">{this.state.registroHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CRM-UF <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    as="select" 
                                                    name="registro_uf" 
                                                    value={this.state.registro_uf} 
                                                    required 
                                                    onChange={this.handleChange}
                                                >
                                                    <option value="">Selecione o Estado</option>
                                                    {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="registroUfHelper" className="text-danger">{this.state.registroUfHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4} xs={12} className="d-flex align-items-center">
                                            <Button
                                                type="button"
                                                variant={this.state.crmValidado ? "success" : "secondary"}
                                                size="sm"
                                                className="mt-2"
                                                disabled={this.state.loadingCRM || this.state.crmValidado}
                                                onClick={this.consultaCRM}
                                            >
                                                {this.state.loadingCRM ? (
                                                    <span><i className="spinner-border spinner-border-sm" /> Validando...</span>
                                                ) : this.state.crmValidado ? (
                                                    <span>✓ CRM Validado</span>
                                                ) : (
                                                    <span>Validar CRM</span>
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>

                                    {this.state.crmValidado && (
                                    <Row>
                                        {this.state.tipo_pessoa === 'fisica' ? (
                                        <>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="nome" 
                                                        required 
                                                        placeholder="Nome" 
                                                        value={this.state.nome} 
                                                        onChange={this.handleChange}
                                                        disabled={!this.state.prestador_id}
                                                    />    
                                                    <Form.Text id="nomeHelper" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                                    {!this.state.prestador_id && (
                                                        <Form.Text className="text-muted">Nome preenchido automaticamente pela validação do CRM</Form.Text>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            {!this.handleOcultoMedico('cpf') && (
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>CPF</Form.Label>
                                                        <Form.Control as={IMaskInput} unmask="typed" mask="000.000.000-00" placeholder="CPF" name="cpf" value={this.state.cpf} onAccept={this.handleMaskAccept('cpf')} />
                                                        <Form.Text id="cpfHelper" className="text-danger">{this.state.cpfHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            )}
                                            <Col sm={6} xs={12}>
                                                <Form.Label>Gênero <span className="text-danger">*</span></Form.Label>
                                                <div className="mb-3">
                                                {
                                                    Object.keys(this.list_generos).map((key, index) => (
                                                    <Form.Check inline type="radio" label={this.list_generos[key]} key={key} id={key} name="genero" value={key} onChange={this.handleChange} checked={ key === this.state.genero ? true : false } />
                                                    ))
                                                }
                                                </div>
                                            </Col>
                                        </>
                                        ) : (
                                        <>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CNPJ <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control as={IMaskInput} unmask="typed" required mask="00.000.000/0000-00" placeholder="CNPJ" name="cnpj" value={this.state.cnpj} onAccept={this.handleMaskAccept('cnpj')} />
                                                    <Form.Text id="cnpjHelper" className="text-danger">{this.state.cnpjHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Razão social <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="razao_social" required placeholder="Razão Social" value={this.state.razao_social} onChange={this.handleChange} />
                                                    <Form.Text id="razaoSocialHelper" className="text-danger">{this.state.razaoSocialHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome fantasia <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" name="nome_fantasia" required placeholder="Nome fantasia" value={this.state.nome_fantasia} onChange={this.handleChange} />
                                                    <Form.Text id="nomeFantasiaHelper" className="text-danger">{this.state.nomeFantasiaHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </>
                                        )}
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>E-mail do médico</Form.Label>
                                                <Form.Control type="email" name="email" placeholder="Email" value={this.state.email} onChange={this.handleChange} />    
                                                <Form.Text id="emailHelper" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Telefone</Form.Label>
                                                <Form.Control as={IMaskInput} unmask="typed" mask="(00) 00000-0000" placeholder="Telefone do médico" name="telefone" value={this.state.telefone} onAccept={this.handleMaskAccept('telefone')} />
                                                <Form.Text id="telefoneHelper" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Celular</Form.Label>
                                                <Form.Control as={IMaskInput} unmask="typed" mask="(00) 00000-0000" placeholder="Celular do médico" name="celular" value={this.state.celular} onAccept={this.handleMaskAccept('celular')} />
                                                <Form.Text id="celularHelper" className="text-danger">{this.state.celularHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Especialidade</Form.Label>
                                                <AsyncSelect
                                                    isMulti
                                                    cacheOptions
                                                    loadOptions={this.carregarEspecialidades}
                                                    defaultOptions
                                                    name="especialidades_medicas"
                                                    placeholder="Buscar especialidade..."
                                                    noOptionsMessage={() => "Nenhuma especialidade encontrada"}
                                                    onChange={(selectedOption) => this.handleEspecialidadesChange(selectedOption)}
                                                    value={this.state.especialidades_medicas}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col sm={12} className="mb-3">
                                            <Card className="border-light bg-light">
                                                <Card.Body className="py-2">
                                                    <Row className="align-items-center">
                                                        <Col sm={3}>
                                                            <Form.Label className="mb-0 fw-bold">Status do Médico:</Form.Label>
                                                        </Col>
                                                        <Col sm={9}>
                                                            <Form.Check
                                                                inline
                                                                type="radio"
                                                                label="Ativo"
                                                                name="is_active"
                                                                id="status_ativo"
                                                                checked={this.state.is_active === true}
                                                                onChange={() => this.setState({ is_active: true })}
                                                                className="me-4"
                                                            />
                                                            <Form.Check
                                                                inline
                                                                type="radio"
                                                                label="Inativo"
                                                                name="is_active"
                                                                id="status_inativo"
                                                                checked={this.state.is_active === false}
                                                                onChange={() => this.setState({ is_active: false })}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                        {/*(this.state.categoria == 'multiprofissionais')  && (
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Categoria de Multiprofissional</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarCategoriaMultiprofissional}
                                                    defaultOptions
                                                    name="categoria_multiprofissional_id"
                                                    placeholder="Buscar categoria..."
                                                    noOptionsMessage={() => "Nenhuma categoria multiprofissional encontrada"}
                                                    onChange={e => this.handleChange(e, 'categoria_multiprofissional_id')}
                                                    value={this.state.categoria_multiprofissional_id ? { value: this.state.categoria_multiprofissional_id, label: this.state.categoria_multiprofissional_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {this.state.categoria_multiprofissional_id  && (
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Multíplas Especialidades</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarEspecialidadeMultiprofissional}
                                                    defaultOptions
                                                    name="especialidade_multiprofissional_id"
                                                    placeholder="Buscar especialidade ..."
                                                    noOptionsMessage={() => "Nenhuma especialidade multiprofissional encontrada"}
                                                    onChange={e => this.handleChange(e, 'especialidade_multiprofissional_id')}
                                                    value={this.state.especialidade_multiprofissional_id ? { value: this.state.especialidade_multiprofissional_id, label: this.state.especialidade_multiprofissional_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )*/}

                                        {this.state.categoria === 'multiprofissionais' && (
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Médico que indicou (opcional)</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    isClearable
                                                    loadOptions={this.carregarMedicosParaIndicacao}
                                                    defaultOptions
                                                    name="medico_indicou_id"
                                                    placeholder="Buscar médico..."
                                                    noOptionsMessage={() => "Nenhum médico encontrado"}
                                                    onChange={e => this.handleChange(e, 'medico_indicou_id')}
                                                    value={this.state.medico_indicou_id ? { value: this.state.medico_indicou_id, label: this.state.medico_indicou_nome } : null}
                                                />
                                                <Form.Text muted>
                                                    Registro de qual médico indicou este multiprofissional. Ajuda o acompanhamento e prepara o próximo escopo de Indicação de Profissional.
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {(this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais') && (
                                        <>
                                            {cachedPogramaTipo === 'medimentor' && (
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>É Mentor?</Form.Label>
                                                        <div>
                                                            <Button
                                                                variant={this.state.mentor ? "success" : "outline-secondary"}
                                                                onClick={() => this.setState({ mentor: true })}>
                                                                Sim
                                                            </Button>
                                                            {' '}
                                                            <Button
                                                                variant={!this.state.mentor ? "danger" : "outline-secondary"}
                                                                onClick={() => this.setState({ mentor: false })}>
                                                                Não
                                                            </Button>
                                                        </div>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            )}
                                        </>
                                        )}
                                        {!this.handleOcultoMedico('nome_contato') && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome do contato</Form.Label>
                                                    <Form.Control type="text" name="contato_nome" placeholder="Nome do contato" value={this.state.contato_nome} onChange={this.handleChange} />
                                                    <Form.Text id="contatoNomeHelper" className="text-danger">{this.state.contatoNomeHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {!this.handleOcultoMedico('email_contato') && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Email do contato</Form.Label>
                                                    <Form.Control type="mail" name="contato_email" placeholder="Email do contato" value={this.state.contato_email} onChange={this.handleChange} />
                                                    <Form.Text id="contatoEmailHelper" className="text-danger">{this.state.contatoEmailHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {!this.handleOcultoMedico('celular_contato') && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Celular do contato</Form.Label>
                                                    <Form.Control as={IMaskInput} unmask="typed" mask="(00) 00000-0000" placeholder="Celular do contato" name="contato_celular" value={this.state.contato_celular} onAccept={this.handleMaskAccept('contato_celular')} />
                                                    <Form.Text id="contatoCelularHelper" className="text-danger">{this.state.contatoCelularHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        {!this.handleOcultoMedico('representante') && (
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Representante</Form.Label>
                                                    <Form.Control type="text" name="representante" placeholder="Representante" value={this.state.representante} onChange={this.handleChange} />
                                                    <Form.Text id="representanteHelper" className="text-danger">{this.state.representanteHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        )}
                                        <Col sm={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Preferências de contato</Form.Label>
                                                <div>
                                                {Object.entries(MidiasAceita).map(([key, label]) => (
                                                    <Form.Check
                                                    inline
                                                    type="checkbox"
                                                    id={`midia-contato-${key}`}
                                                    label={label}
                                                    value={key}
                                                    checked={this.state.midiasContato.includes(key)}
                                                    onChange={this.handleMidiasChange}
                                                    key={key}
                                                    />
                                                ))}
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    )}
                                    {this.state.crmValidado && !this.handleOcultoMedico('endereco') && ( 
                                    <>
                                        <h4 className="mt-3">Endereço</h4>
                                        <Row>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CEP</Form.Label>
                                                    <Form.Control as={IMaskInput} unmask="typed" mask="00000-000" type="text" placeholder="CEP" value={this.state.cep} onAccept={(val) => this.setState({ cep: val })} onComplete={(val) => this.fetchCep(val)} />
                                                    <Form.Text id="cepHelper" className="text-danger">{this.state.cepHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>UF</Form.Label>
                                                    <Form.Control as="select" name="uf" value={this.state.uf} onChange={this.handleChange}>
                                                        <option value="">Selecione o Estado</option>
                                                        {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                            <option key={sigla} value={sigla}>{nome}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text id="ufHelper" className="text-danger">{this.state.ufHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Cidade</Form.Label>
                                                    <Form.Control type="text" name="cidade" placeholder="Cidade" value={this.state.cidade} onChange={this.handleChange} />    
                                                    <Form.Text id="cidadeHelper" className="text-danger">{this.state.cidadeHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Bairro</Form.Label>
                                                    <Form.Control type="text" name="bairro" placeholder="Bairro" value={this.state.bairro} onChange={this.handleChange} />    
                                                    <Form.Text id="bairroHelper" className="text-danger">{this.state.bairroHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Endereço</Form.Label>
                                                    <Form.Control type="text" name="endereco" placeholder="Endereço" value={this.state.endereco} onChange={this.handleChange} />    
                                                    <Form.Text id="enderecoHelper" className="text-danger">{this.state.enderecoHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Número</Form.Label>
                                                    <Form.Control type="text" name="numero" placeholder="Número" value={this.state.numero} onChange={this.handleChange} />    
                                                    <Form.Text id="numeroHelper" className="text-danger">{this.state.numeroHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Complemento</Form.Label>
                                                    <Form.Control type="text" name="complemento" placeholder="Complemento" value={this.state.complemento} onChange={this.handleChange} />    
                                                    <Form.Text id="complementoHelper" className="text-danger">{this.state.complementoHelper}</Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>
                                    )}
                                    {hasPerm('add_programas_prestadores') && !this.state.programa_id && !dados_usuario['ambiente_programa_id'] && this.state.crmValidado && (
                                    <Row>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Acesso exclusivo de programa?</Form.Label>
                                                <div>
                                                    <Button
                                                        variant={this.state.acesso_unico ? "success" : "outline-secondary"}
                                                        onClick={() => this.setState({ acesso_unico: true })}>
                                                        Sim
                                                    </Button>
                                                    {' '}
                                                    <Button
                                                        variant={!this.state.acesso_unico ? "danger" : "outline-secondary"}
                                                        onClick={() => this.setState({ acesso_unico: false })}>
                                                        Não
                                                    </Button>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    )}
                                    {hasPerm('add_programas_prestadores') && this.state.acesso_unico && !dados_usuario['ambiente_programa_id'] && this.state.crmValidado && (
                                        <>
                                            <h4 className="mt-3">Programa</h4>
                                            <Row>
                                                <Col sm={4}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cliente</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregarClientesPrograma}
                                                            defaultOptions
                                                            name="cliente_id"
                                                            placeholder="Buscar cliente..."
                                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                            onChange={e => this.handleChange(e, 'cliente_id')}
                                                            value={this.state.cliente_id ? { value: this.state.cliente_id, label: this.state.cliente_nome } : null}
                                                            isDisabled={this.props.dados_cliente?.cliente_id}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                {this.state.cliente_id && (
                                                    <>
                                                        <Col sm={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Programa:</Form.Label>
                                                                <AsyncSelect
                                                                    key={this.state.cliente_id}
                                                                    defaultOptions
                                                                    loadOptions={(inputValue) => this.carregarProgramasCliente(inputValue, this.state.cliente_id)}
                                                                    name="programa_uuid"
                                                                    placeholder="Buscar programa..."
                                                                    noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                    onChange={e => this.handleChange(e, 'programa_uuid')}
                                                                    value={this.state.programa_uuid ? { value: this.state.programa_uuid, label: this.state.programa_nome } : null}
                                                                    isDisabled={this.props.dados_programa?.programa_uuid}
                                                                />
                                                            </Form.Group>
                                                        </Col>
                                                        {/*<Col sm={4}>
                                                            <Form.Group className="mb-1">
                                                                <Form.Label>Termo</Form.Label>
                                                                <AsyncSelect
                                                                    cacheOptions
                                                                    loadOptions={this.carregarTermos}
                                                                    defaultOptions
                                                                    name="termo_prestador_id"
                                                                    placeholder="Buscar termo..."
                                                                    noOptionsMessage={() => "Nenhum termo encontrado"}
                                                                    onChange={e => this.handleChange(e, 'termo_prestador_id')}
                                                                    value={this.state.termo_prestador_id ? { value: this.state.termo_prestador_id, label: this.state.termo_prestador_nome } : null}
                                                                />
                                                            </Form.Group>
                                                            <Form.Check
                                                                className="mb-3"
                                                                type="checkbox"
                                                                name="assinatura_letssign"
                                                                id="assinatura_letssign"
                                                                label="Assinatura LetsSign"
                                                                checked={this.state.assinatura_letssign ? true : false}
                                                                onChange={e => this.handleChange(e, 'assinatura_letssign')}
                                                            />
                                                        </Col>
                                                        <Col sm={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Alerta do atendimento</Form.Label>
                                                                <Form.Control
                                                                    as="textarea"
                                                                    name="alerta_atendimento"
                                                                    value={this.state.alerta_atendimento}
                                                                    onChange={this.handleChange}
                                                                    className="custom-textarea3"
                                                                />
                                                            </Form.Group>
                                                        </Col>*/}
                                                    </>
                                                )}
                                            </Row>
                                        </>
                                    )}

                                    {!this.state.prestador_id && (dados_usuario['tipo_usuario'] === '' || hasPerm('add_user')) && this.state.crmValidado && (
                                        <>
                                            <h4 className="mt-3">Dados de Acesso</h4>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Grupo de Usuário</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            loadOptions={this.carregarGrupos}
                                                            defaultOptions
                                                            name="grupo_id"
                                                            placeholder="Buscar grupo..."
                                                            noOptionsMessage={() => "Nenhum grupo encontrado"}
                                                            onChange={this.onChangeGrupo}
                                                            value={this.state.grupo_id ? { value: this.state.grupo_id, label: this.state.grupo_nome } : null}
                                                        />
                                                        <Form.Text className="text-danger">{this.state.grupoIdHelper}</Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3 position-relative">
                                                        <Form.Label>Senha <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type={this.state.mostrarSenha.senha ? "text" : "password"}
                                                            name="senha"
                                                            placeholder="Senha"
                                                            value={this.state.senha}
                                                            onChange={this.handleChange}
                                                        />
                                                        <i
                                                            onClick={() => this.toggleSenhaVisibilidade('senha')}
                                                            className="senha-icon"
                                                            style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                        >
                                                            {this.state.mostrarSenha.senha ? <FaEyeSlash /> : <FaEye />}
                                                        </i>
                                                    </Form.Group>
                                                    <p className="mb-0">Requisitos da senha: </p>
                                                    <ul>
                                                        <li style={{ color: this.state.requisitosSenha.tamanho ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.tamanho ? '700' : '400' }}>
                                                            Quantidade de caracteres maior que 8 {this.state.requisitosSenha.tamanho && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.minuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.minuscula ? '700' : '400' }}>
                                                            Uma letra minuscula {this.state.requisitosSenha.minuscula && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.maiuscula ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.maiuscula ? '700' : '400' }}>
                                                            Uma letra maiuscula {this.state.requisitosSenha.maiuscula && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.numero ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.numero ? '700' : '400' }}>
                                                            Um número de 0 a 9 {this.state.requisitosSenha.numero && <FaCheck />}
                                                        </li>
                                                        <li style={{ color: this.state.requisitosSenha.especial ? '#3cc172' : 'black', fontWeight: this.state.requisitosSenha.especial ? '700' : '400' }}>
                                                            Pelo menos um dos seguintes caracteres $@#&! {this.state.requisitosSenha.especial && <FaCheck />}
                                                        </li>
                                                    </ul>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3 position-relative">
                                                        <Form.Label>Confirmar Senha <span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            type={this.state.mostrarSenha.senhaConfirma ? "text" : "password"}
                                                            name="senha_confirma"
                                                            placeholder="Confirmar Senha"
                                                            value={this.state.senha_confirma}
                                                            onChange={this.handleChange}
                                                        />
                                                        <i
                                                            onClick={() => this.toggleSenhaVisibilidade('senhaConfirma')}
                                                            className="senha-icon"
                                                            style={{ position: 'absolute', right: '10px', top: '38px', cursor: 'pointer' }}
                                                        >
                                                            {this.state.mostrarSenha.senhaConfirma ? <FaEyeSlash /> : <FaEye />}
                                                        </i>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </>
                                    )}
                                    {this.state.prestador_id && (
                                        <div className="mt-4">
                                            <h5>Preferências de Comunicação</h5>
                                            <Form.Check
                                                type="switch"
                                                id="receber-comunicacoes-switch"
                                                label="Aceita receber comunicações"
                                                checked={this.state.receber_comunicacoes}
                                                onChange={(e) => this.setState({ receber_comunicacoes: e.target.checked })}
                                            />
                                            {this.renderBotaoAceitesProgramaAtual()}
                                        </div>
                                    )}

                                    {this.state.erroLoadRegistro ?
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }
                                    {this.state.crmValidado && this.renderTermosDinamicosCadastroMedico()}
                                    {this.state.crmValidado && (
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                    )}
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>

                    {this.state.prestador_id &&  hasPerm('add_programas_prestadores') && !dados_usuario['ambiente_programa_id'] && (
                        <Tab eventKey="programasPrestador" title="Programas">
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Form onSubmit={this.enviaProgramasPrestador}>
                                        <h4>Programas do Prestador</h4>
                                        {this.state.programas.map((programa, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cliente</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarClientesPrograma}
                                                                defaultOptions
                                                                name="cliente_id"
                                                                placeholder="Buscar cliente..."
                                                                noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                                onChange={e => this.handleProgramaChange(index, e, 'cliente_id')}
                                                                value={programa.cliente_id ? { value: programa.cliente_id, label: programa.cliente_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {programa.cliente_id && (
                                                        <>
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Programa</Form.Label>
                                                                    <AsyncSelect
                                                                        key={programa.keyPrograma}
                                                                        cacheOptions
                                                                        loadOptions={(inputValue) => this.carregarProgramasClienteRepetidor(inputValue, programa.cliente_id)}
                                                                        defaultOptions
                                                                        name="programa_id"
                                                                        placeholder="Buscar programa..."
                                                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                        onChange={e => this.handleProgramaChange(index, e, 'programa_id')}
                                                                        value={programa.programa_id ? { value: programa.programa_id, label: programa.programa_nome } : null}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={4}>
                                                                <Form.Group className="mb-1">
                                                                    <Form.Label>Termo</Form.Label>
                                                                    <AsyncSelect
                                                                        key={programa.keyPrograma + 999}
                                                                        cacheOptions
                                                                        loadOptions={this.carregarTermos}
                                                                        defaultOptions
                                                                        name="termo_prestador_id"
                                                                        placeholder="Buscar termo..."
                                                                        noOptionsMessage={() => "Nenhum termo encontrado"}
                                                                        onChange={e => this.handleProgramaChange(index, e, 'termo_prestador_id')}
                                                                        value={programa.termo_prestador_id ? { value: programa.termo_prestador_id, label: programa.termo_prestador_nome } : null}
                                                                    />
                                                                </Form.Group>
                                                                <Form.Check
                                                                    className="mb-3"
                                                                    type="checkbox"
                                                                    name="assinatura_letssign"
                                                                    id={'assinatura_letssign_' + index}
                                                                    label="Assinatura LetsSign"
                                                                    checked={programa.assinatura_letssign ? true : false}
                                                                    onChange={e => this.handleProgramaChange(index, e, 'assinatura_letssign')}
                                                                />
                                                            </Col>
                                                            <Col sm={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Alerta do atendimento</Form.Label>
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        name="alerta_atendimento"
                                                                        value={programa.alerta_atendimento}
                                                                        onChange={e => this.handleProgramaChange(index, e, 'alerta_atendimento')}
                                                                        className="custom-textarea3"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={12} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Laboratório com exclusividade</Form.Label>
                                                                    <Form.Check
                                                                        type="checkbox"
                                                                        name="exclusivo_vinculados"
                                                                        id={'exclusivo_vinculados_' + index}
                                                                        label="Médicos vinculados ao laboratório só podem solicitar atendimento para o laboratório"
                                                                        checked={programa.exclusivo_vinculados ? true : false}
                                                                        onChange={e => this.handleProgramaChange(index, e, 'exclusivo_vinculados')}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </>
                                                    )}
                                                </Row>
                                                <Button variant="success" className="btn-sm" onClick={() => this.salvarPrograma(index)}><FaCheck className="me-1" /> Salvar Programa</Button>&nbsp;&nbsp;
                                                <Button variant="danger" className="btn-sm ml-3" onClick={() => this.removerPrograma(index)}><FaTimes className="me-1" /> Remover Programa</Button>
                                                {this.temAceiteRegistrado(programa) && (
                                                    <>
                                                        &nbsp;&nbsp;
                                                        <Button variant="outline-secondary" className="btn-sm" onClick={() => this.abrirModalAceites(programa)}>Ver aceites</Button>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarPrograma}><FaStream /> Adicionar Programa</Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}

                    {this.state.prestador_id && dados_usuario['tipo_usuario'] == '' && (this.state.categoria == 'medicos' || this.state.categoria == 'multiprofissionais')  && (
                        <Tab eventKey="laboratoriosPrestador" title="Laboratórios">
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Form onSubmit={this.enviaClientesPrestador}>
                                        <h4>Laboratórios do Prestador</h4>
                                        {this.state.laboratorios.map((laboratorio, index) => (
                                            <div key={index} className="row-list">
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Laboratório</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarLaboratorios}
                                                                defaultOptions
                                                                name="laboratorio_id"
                                                                placeholder="Buscar laboratório..."
                                                                noOptionsMessage={() => "Nenhum laboratório encontrado"}
                                                                onChange={e => this.handleLaboratorioChange(index, e, 'laboratorio_id')}
                                                                value={laboratorio.laboratorio_id ? { value: laboratorio.laboratorio_id, label: laboratorio.laboratorio_nome } : null}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {!laboratorio.id && (
                                                    <Button variant="success" className="btn-sm me-2" onClick={() => this.salvarLaboratorio(index)}><FaCheck className="me-1" /> Salvar Laboratório</Button>
                                                )}
                                                <Button variant="danger" className="btn-sm" onClick={() => this.removerLaboratorio(index)}><FaTimes className="me-1" /> Remover Laboratório</Button>
                                            </div>
                                        ))}
                                        <Button variant="secondary" onClick={this.adicionarLaboratorio}><FaStream /> Adicionar Laboratório</Button>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}              

                    {/* A aba aparece quando o programa exige aceite manual (fluxo de solicitação) ou
                        quando existem respostas do médico para consultar. */}
                    {this.state.prestador_id && (this.state.exige_aceite_termo_opt_in_medicos || this.temRespostasTermosParaConsulta()) && (
                        <Tab eventKey="termosOptin" title="Termos">
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <h4>Termos e Opt-in</h4>
                                    <Row className="mb-4">
                                        <Col sm={12}>
                                            <Alert variant={this.state.data_aceite_termo ? "success" : "warning"}>
                                                <strong>Status do Aceite:</strong>{' '}
                                                {this.state.data_aceite_termo ? (
                                                    <>Aceito em <strong>{new Date(this.state.data_aceite_termo).toLocaleDateString('pt-BR')}</strong></>
                                                ) : (
                                                    'Pendente de aceite'
                                                )}
                                            </Alert>
                                        </Col>
                                    </Row>

                                    {/* a seção de reenvio, logo abaixo, já lista os aceites; sem esta
                                        segunda condição eles apareciam duas vezes na aba */}
                                    {!this.state.exige_aceite_termo_opt_in_medicos && !this.temRespostasTermosParaConsulta() && (
                                        <Row>
                                            <Col sm={12}>
                                                {this.renderAceitesTermosPersonalizadosPrograma()}
                                            </Col>
                                        </Row>
                                    )}

                                    {/* Reenviar o termo vale também para quem usa termos dinâmicos e não
                                        o opt-in clássico (caso do Conecta PKU): a navegadora precisa
                                        conseguir mandar o link do aceite para o médico de qualquer forma. */}
                                    {(this.state.exige_aceite_termo_opt_in_medicos || this.temRespostasTermosParaConsulta()) && (
                                    <Row>
                                        <Col sm={6}>
                                            <h5>Enviar Solicitação de Aceite</h5>
                                            <p className="text-muted">
                                                Envia um e-mail para o médico com o link para aceitar os termos do programa.
                                            </p>
                                            <div className="d-flex gap-2 flex-wrap">
                                                {/* também depois do aceite: o termo pode mudar de versão,
                                                    o médico pode ter perdido o e-mail ou aceitado o termo errado */}
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    onClick={this.enviarSolicitacaoOptin}
                                                    disabled={this.state.enviando_solicitacao_optin || !this.state.email}
                                                >
                                                    {this.state.enviando_solicitacao_optin ? (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    ) : (
                                                        <><FaEnvelope className="me-1" /> {this.state.data_aceite_termo ? 'Reenviar Solicitação por E-mail' : 'Enviar Solicitação por E-mail'}</>
                                                    )}
                                                </Button>
                                                {this.state.prestador_uuid && (
                                                    <Button 
                                                        variant="outline-secondary" 
                                                        onClick={this.copiarLinkAceiteTermos}
                                                    >
                                                        Copiar Link
                                                    </Button>
                                                )}
                                            </div>
                                            {!this.state.email && (
                                                <small className="text-danger d-block mt-2">
                                                    O médico não possui e-mail cadastrado.
                                                </small>
                                            )}

                                            {this.state.nps_termos_campos_dinamicos && this.state.nps_termos_campos_dinamicos.ativo && (
                                                <div className="mt-4">
                                                    <h5>{this.state.nps_termos_campos_dinamicos.titulo || "Termos Personalizados"}</h5>
                                                    {this.state.nps_termos_campos_dinamicos.perguntas.map((pergunta, index) => (
                                                        <Form.Group key={pergunta.slug} className="mb-3">
                                                            
                                                            {(
                                                                <div>
                                                                    <Form.Check
                                                                        type="switch"
                                                                        id={`${pergunta.slug}-switch`}
                                                                        label={pergunta.label}
                                                                        name={pergunta.slug}
                                                                        checked={this.state.nps_termos_campos_dinamicos_respostas[pergunta.slug] === true}
                                                                        onChange={(e) => this.handleTermoDinamicoChange(pergunta.slug, e.target.checked)}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    ))}
                                                </div>
                                            )}

                                            {this.renderAceitesTermosPersonalizadosPrograma()}
                                        </Col>
                                        <Col sm={6}>
                                            <h5>Termos Assinados (Upload Manual)</h5>
                                            <p className="text-muted">
                                                Envie PDFs dos termos assinados fisicamente. Você pode enviar quantos arquivos forem necessários.
                                            </p>

                                            {/* Lista de termos já enviados */}
                                            {this.state.termo_assinado_optin_medicos && this.state.termo_assinado_optin_medicos.length > 0 && (
                                                <div className="mb-3">
                                                    <strong className="d-block mb-2">Termos Enviados:</strong>
                                                    {this.state.termo_assinado_optin_medicos.map((termo, index) => (
                                                        <div key={index} className="d-flex align-items-center gap-2 mb-2 p-2 border rounded bg-light">
                                                            <FaFilePdf className="text-danger" />
                                                            <a 
                                                                href={termo.url_assinada || termo.url} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                className="flex-grow-1 text-truncate"
                                                                title={termo.nome}
                                                            >
                                                                {termo.nome || `Termo ${index + 1}`}
                                                            </a>
                                                            <small className="text-muted me-2">
                                                                {termo.data_upload ? new Date(termo.data_upload).toLocaleDateString('pt-BR') : ''}
                                                            </small>
                                                            <Button 
                                                                variant="outline-danger" 
                                                                size="sm"
                                                                onClick={() => this.removerTermoAssinado(termo.url)}
                                                                disabled={this.state.uploadingTermoAssinado}
                                                                title="Remover termo"
                                                            >
                                                                <FaTrash />
                                                            </Button>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}

                                            {/* Upload de novos termos */}
                                            <Form.Group className="mb-3">
                                                <Form.Label className="d-flex align-items-center gap-2">
                                                    <FaPlus className="text-primary" /> Adicionar Termo(s)
                                                </Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    accept=".pdf"
                                                    multiple
                                                    onChange={this.onChangeTermoAssinado}
                                                    disabled={this.state.uploadingTermoAssinado}
                                                />
                                                <Form.Text className="text-muted">
                                                    Selecione um ou mais arquivos PDF para enviar.
                                                </Form.Text>
                                                {this.state.uploadingTermoAssinado && (
                                                    <small className="text-primary d-block mt-1">
                                                        <span className="spinner-border spinner-border-sm me-1"></span>
                                                        Enviando arquivo(s)...
                                                    </small>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    )}
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}

                    {/* Tab de Centros de Referência */}
                    {this.state.prestador_id && !ocultar_centros_referencia && (
                        <Tab eventKey="centrosReferencia" title="Centros de Referência">
                            <PrestadorCentrosReferencia prestadorId={this.state.prestador_id} />
                        </Tab>
                    )}

                    {/* Tab de Kits */}
                    {this.state.prestador_id && this.state.programa_id && !ocultar_kits && (
                        <Tab eventKey="kitsPrestador" title="Kits">
                            <PrestadorKits
                                prestadorId={this.state.prestador_id}
                                programaId={this.state.programa_id}
                            />
                        </Tab>
                    )}

                    {/* Tab de Acesso - Gestão de Usuários */}
                    {this.state.prestador_id && (
                        <Tab eventKey="acessoMedico" title="Acesso">
                            <Card className="cardDestaque">
                                <Card.Body>
                                    <Row className="mb-3">
                                        <Col>
                                            <h4>Gestão de Usuários</h4>
                                            <p className="text-muted">Crie e gerencie usuários de acesso para este médico</p>
                                        </Col>
                                        <Col className="text-end">
                                            <Button variant="success" size="sm" onClick={() => this.handleShowModalUsuario()}>
                                                <FaPlus className="me-1" /> Adicionar Usuário
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Table responsive className="custom-table mt-3">
                                        <thead>
                                            <tr>
                                                <th>Ativo</th>
                                                <th>Nome</th>
                                                <th>Email</th>
                                                <th>Username</th>
                                                <th>Grupo de Permissões</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.loading ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        Carregando...
                                                    </td>
                                                </tr>
                                            ) : this.state.usuarios.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        Nenhum usuário cadastrado
                                                    </td>
                                                </tr>
                                            ) : (
                                                this.state.usuarios.map(usuario => (
                                                    <tr key={usuario.id}>
                                                        <td>
                                                            {usuario.is_active ? (
                                                                <span className="badge bg-success">Ativo</span>
                                                            ) : (
                                                                <span className="badge bg-danger">Inativo</span>
                                                            )}
                                                        </td>
                                                        <td>{usuario.first_name} {usuario.last_name}</td>
                                                        <td>{usuario.email}</td>
                                                        <td>{usuario.username}</td>
                                                        <td>{usuario.grupo_id?.label || 'Sem grupo'}</td>
                                                        <td>
                                                            <Button 
                                                                variant="primary" 
                                                                size="sm" 
                                                                className="me-2"
                                                                onClick={() => this.handleShowModalUsuario(usuario)}
                                                            >
                                                                Editar
                                                            </Button>
                                                            <Button 
                                                                variant="danger" 
                                                                size="sm"
                                                                onClick={() => this.handleRemoverUsuario(usuario.id)}
                                                            >
                                                                Inativar
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </Table>
                                    {this.renderModalUsuario()}
                                </Card.Body>
                            </Card>
                        </Tab>
                    )}
                </Tabs>

                <ModalAceitesPrograma
                    show={!!this.state.vinculoAceitesModal}
                    vinculo={this.state.vinculoAceitesModal}
                    receberComunicacoes={this.state.receber_comunicacoes}
                    onHide={this.fecharModalAceites}
                />
            </div>
        )
    }
}

export default withRouter(MedicosEdit);
